// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AccountsListData, AccountsListResponse, AccountsCreateData, AccountsCreateResponse, AccountsRetrieveData, AccountsRetrieveResponse, AccountsUpdateData, AccountsUpdateResponse, AccountsPartialUpdateData, AccountsPartialUpdateResponse, AccountsDestroyData, AccountsDestroyResponse, AccountsAvailabilityTokenRetrieveData, AccountsAvailabilityTokenRetrieveResponse, ActaportCollisionsCollisionsCreateData, ActaportCollisionsCollisionsCreateResponse, ActaportPartyMatchingFindMatchesCreateData, ActaportPartyMatchingFindMatchesCreateResponse, ActionAutoCommitSettingsListData, ActionAutoCommitSettingsListResponse, ActionAutoCommitSettingsCreateData, ActionAutoCommitSettingsCreateResponse, ActionAutoCommitSettingsRetrieveData, ActionAutoCommitSettingsRetrieveResponse, ActionAutoCommitSettingsUpdateData, ActionAutoCommitSettingsUpdateResponse, ActionAutoCommitSettingsPartialUpdateData, ActionAutoCommitSettingsPartialUpdateResponse, ActionAutoCommitSettingsDestroyData, ActionAutoCommitSettingsDestroyResponse, ActionAutoCommitSettingsAvailableActionsRetrieveResponse, ActivitiesListData, ActivitiesListResponse, ActivitiesCreateData, ActivitiesCreateResponse, ActivitiesRetrieveData, ActivitiesRetrieveResponse, ActivitiesUpdateData, ActivitiesUpdateResponse, ActivitiesPartialUpdateData, ActivitiesPartialUpdateResponse, ActivitiesDestroyData, ActivitiesDestroyResponse, ActivitiesMarkSeenCreateData, ActivitiesMarkSeenCreateResponse, ActivitiesMarkUnseenCreateData, ActivitiesMarkUnseenCreateResponse, ActivitiesUnseenCountRetrieveResponse, AdvowareRolesGetRoleMappingsCreateData, AdvowareRolesGetRoleMappingsCreateResponse, AgentActionsListData, AgentActionsListResponse, AgentActionsCreateData, AgentActionsCreateResponse, AgentActionsRetrieveData, AgentActionsRetrieveResponse, AgentActionsUpdateData, AgentActionsUpdateResponse, AgentActionsPartialUpdateData, AgentActionsPartialUpdateResponse, AgentActionsDestroyData, AgentActionsDestroyResponse, AgentActionsCaseCreateInstructionsAdvisoryCreateData, AgentActionsCaseCreateInstructionsAdvisoryCreateResponse, AgentActionsCommitCreateData, AgentActionsCommitCreateResponse, AgentActionsRateCreateData, AgentActionsRateCreateResponse, AgentActionsRevertCreateData, AgentActionsRevertCreateResponse, AiAnalysisListData, AiAnalysisListResponse, AiAnalysisCreateData, AiAnalysisCreateResponse, AiAnalysisRetrieveData, AiAnalysisRetrieveResponse, AiAnalysisUpdateData, AiAnalysisUpdateResponse, AiAnalysisPartialUpdateData, AiAnalysisPartialUpdateResponse, AiAnalysisDestroyData, AiAnalysisDestroyResponse, AiAnalysisByDocumentUuidListData, AiAnalysisByDocumentUuidListResponse, AiAugmentationListData, AiAugmentationListResponse, AiAugmentationCreateData, AiAugmentationCreateResponse, AiAugmentationRetrieveData, AiAugmentationRetrieveResponse, AiAugmentationUpdateData, AiAugmentationUpdateResponse, AiAugmentationPartialUpdateData, AiAugmentationPartialUpdateResponse, AiAugmentationDestroyData, AiAugmentationDestroyResponse, AiAugmentationByDocumentUuidListData, AiAugmentationByDocumentUuidListResponse, AiChatQuestionTemplatesListData, AiChatQuestionTemplatesListResponse, AiChatQuestionTemplatesCreateData, AiChatQuestionTemplatesCreateResponse, AiChatQuestionTemplatesRetrieveData, AiChatQuestionTemplatesRetrieveResponse, AiChatQuestionTemplatesUpdateData, AiChatQuestionTemplatesUpdateResponse, AiChatQuestionTemplatesPartialUpdateData, AiChatQuestionTemplatesPartialUpdateResponse, AiChatQuestionTemplatesDestroyData, AiChatQuestionTemplatesDestroyResponse, AiChatQuestionTemplatesCopyCreateData, AiChatQuestionTemplatesCopyCreateResponse, AiChatQuestionTemplatesFavoriteCreateData, AiChatQuestionTemplatesFavoriteCreateResponse, AiChatQuestionTemplatesUnfavoriteCreateData, AiChatQuestionTemplatesUnfavoriteCreateResponse, AiChatQuestionTemplatesGenerateDescriptionCreateData, AiChatQuestionTemplatesGenerateDescriptionCreateResponse, AiChatSessionGroupsListData, AiChatSessionGroupsListResponse, AiChatSessionGroupsCreateData, AiChatSessionGroupsCreateResponse, AiChatSessionGroupsRetrieveData, AiChatSessionGroupsRetrieveResponse, AiChatSessionGroupsUpdateData, AiChatSessionGroupsUpdateResponse, AiChatSessionGroupsPartialUpdateData, AiChatSessionGroupsPartialUpdateResponse, AiChatSessionGroupsDestroyData, AiChatSessionGroupsDestroyResponse, AiChatSessionGroupsChatSessionsRetrieveData, AiChatSessionGroupsChatSessionsRetrieveResponse, AiChatSessionGroupsCreateChatSessionCreateData, AiChatSessionGroupsCreateChatSessionCreateResponse, AiChatSessionsListData, AiChatSessionsListResponse, AiChatSessionsCreateData, AiChatSessionsCreateResponse, AiChatSessionsRetrieveData, AiChatSessionsRetrieveResponse, AiChatSessionsUpdateData, AiChatSessionsUpdateResponse, AiChatSessionsPartialUpdateData, AiChatSessionsPartialUpdateResponse, AiChatSessionsDestroyData, AiChatSessionsDestroyResponse, AiChatSessionsExportPdfCreateData, AiChatSessionsExportPdfCreateResponse, AiChatSessionsSendMessageCreateData, AiChatSessionsSendMessageCreateResponse, AiChatSessionsEnhancePromptCreateData, AiChatSessionsEnhancePromptCreateResponse, AiSettingsListData, AiSettingsListResponse, AiSettingsCreateData, AiSettingsCreateResponse, AiSettingsRetrieveData, AiSettingsRetrieveResponse, AiSettingsUpdateData, AiSettingsUpdateResponse, AiSettingsPartialUpdateData, AiSettingsPartialUpdateResponse, AiSettingsDestroyData, AiSettingsDestroyResponse, AiSettingsAvailableActionsRetrieveResponse, AiSettingsAvailableNotificationActionsRetrieveResponse, AnnouncementsListData, AnnouncementsListResponse, AnnouncementsCreateData, AnnouncementsCreateResponse, AnnouncementsRetrieveData, AnnouncementsRetrieveResponse, AnnouncementsUpdateData, AnnouncementsUpdateResponse, AnnouncementsPartialUpdateData, AnnouncementsPartialUpdateResponse, AnnouncementsDestroyData, AnnouncementsDestroyResponse, AnnouncementsDismissCreateData, AnnouncementsDismissCreateResponse, AnnouncementsHideCreateData, AnnouncementsHideCreateResponse, AnnouncementsActiveListData, AnnouncementsActiveListResponse, AppointmentProposalsListData, AppointmentProposalsListResponse, AppointmentProposalsCreateData, AppointmentProposalsCreateResponse, AppointmentProposalsRetrieveData, AppointmentProposalsRetrieveResponse, AppointmentProposalsUpdateData, AppointmentProposalsUpdateResponse, AppointmentProposalsPartialUpdateData, AppointmentProposalsPartialUpdateResponse, AppointmentProposalsDestroyData, AppointmentProposalsDestroyResponse, AppointmentSettingsRetrieveResponse, AppointmentsListData, AppointmentsListResponse, AppointmentsCreateData, AppointmentsCreateResponse, AppointmentsRetrieveData, AppointmentsRetrieveResponse, AppointmentsUpdateData, AppointmentsUpdateResponse, AppointmentsPartialUpdateData, AppointmentsPartialUpdateResponse, AppointmentsDestroyData, AppointmentsDestroyResponse, AppointmentsCancelCreateData, AppointmentsCancelCreateResponse, AppointmentsConfirmCreateData, AppointmentsConfirmCreateResponse, AppointmentsCreateCaseAppointmentCreateData, AppointmentsCreateCaseAppointmentCreateResponse, CalendarsListData, CalendarsListResponse, CalendarsCreateData, CalendarsCreateResponse, CalendarsRetrieveData, CalendarsRetrieveResponse, CalendarsUpdateData, CalendarsUpdateResponse, CalendarsPartialUpdateData, CalendarsPartialUpdateResponse, CalendarsDestroyData, CalendarsDestroyResponse, CallsListData, CallsListResponse, CallsCreateData, CallsCreateResponse, CallsRetrieveData, CallsRetrieveResponse, CallsUpdateData, CallsUpdateResponse, CallsPartialUpdateData, CallsPartialUpdateResponse, CallsDestroyData, CallsDestroyResponse, CallsCreateCaseCreateData, CallsCreateCaseCreateResponse, CallsGeminiShadowComparisonCreateData, CallsGeminiShadowComparisonCreateResponse, CallsLawyerFeedbackListData, CallsLawyerFeedbackListResponse, CallsLawyerFeedbackCreateData, CallsLawyerFeedbackCreateResponse, CallsLawyerFeedbackRetrieveData, CallsLawyerFeedbackRetrieveResponse, CallsLawyerFeedbackUpdateData, CallsLawyerFeedbackUpdateResponse, CallsLawyerFeedbackPartialUpdateData, CallsLawyerFeedbackPartialUpdateResponse, CallsLawyerFeedbackDestroyData, CallsLawyerFeedbackDestroyResponse, CaseCreationIntegrationCreateData, CaseCreationIntegrationCreateResponse, CaseCreatorTempDocumentsListData, CaseCreatorTempDocumentsListResponse, CaseCreatorTempDocumentsCreateData, CaseCreatorTempDocumentsCreateResponse, CaseCreatorTempDocumentsRetrieveData, CaseCreatorTempDocumentsRetrieveResponse, CaseCreatorTempDocumentsUpdateData, CaseCreatorTempDocumentsUpdateResponse, CaseCreatorTempDocumentsPartialUpdateData, CaseCreatorTempDocumentsPartialUpdateResponse, CaseCreatorTempDocumentsDestroyData, CaseCreatorTempDocumentsDestroyResponse, CaseLifecycleStateReasoningListData, CaseLifecycleStateReasoningListResponse, CaseLifecycleStateReasoningRetrieveData, CaseLifecycleStateReasoningRetrieveResponse, CaseLifecycleStatesListData, CaseLifecycleStatesListResponse, CaseLifecycleStatesCreateData, CaseLifecycleStatesCreateResponse, CaseLifecycleStatesRetrieveData, CaseLifecycleStatesRetrieveResponse, CaseLifecycleStatesUpdateData, CaseLifecycleStatesUpdateResponse, CaseLifecycleStatesPartialUpdateData, CaseLifecycleStatesPartialUpdateResponse, CaseLifecycleStatesDestroyData, CaseLifecycleStatesDestroyResponse, CaseLifecycleStatesAdvanceCreateData, CaseLifecycleStatesAdvanceCreateResponse, CaseLifecycleStatesRateCreateData, CaseLifecycleStatesRateCreateResponse, CaseLifecycleWorkflowsListData, CaseLifecycleWorkflowsListResponse, CaseLifecycleWorkflowsCreateData, CaseLifecycleWorkflowsCreateResponse, CaseLifecycleWorkflowsRetrieveData, CaseLifecycleWorkflowsRetrieveResponse, CaseLifecycleWorkflowsUpdateData, CaseLifecycleWorkflowsUpdateResponse, CaseLifecycleWorkflowsPartialUpdateData, CaseLifecycleWorkflowsPartialUpdateResponse, CaseLifecycleWorkflowsDestroyData, CaseLifecycleWorkflowsDestroyResponse, CaseLifecycleWorkflowsAvailableActionsRetrieveResponse, CasesListData, CasesListResponse, CasesCreateData, CasesCreateResponse, CasesRetrieveData, CasesRetrieveResponse, CasesUpdateData, CasesUpdateResponse, CasesPartialUpdateData, CasesPartialUpdateResponse, CasesDestroyData, CasesDestroyResponse, CasesAiSummaryCreateData, CasesAiSummaryCreateResponse, CasesAppointmentProposalsRetrieveData, CasesAppointmentProposalsRetrieveResponse, CasesAppointmentsListData, CasesAppointmentsListResponse, CasesAssignWorkflowPartialUpdateData, CasesAssignWorkflowPartialUpdateResponse, CasesCreateWordDocumentCreateData, CasesCreateWordDocumentCreateResponse, CasesCreateWordDocumentFromPlaceholderValuesCreateData, CasesCreateWordDocumentFromPlaceholderValuesCreateResponse, CasesCreateWordDocumentPreviewBlobCreateData, CasesCreateWordDocumentPreviewBlobCreateResponse, CasesDocumentsListData, CasesDocumentsListResponse, CasesDownloadDocumentsZipRetrieveData, CasesDownloadDocumentsZipRetrieveResponse, CasesFindWordDocumentTemplatePlaceholderValuesCreateData, CasesFindWordDocumentTemplatePlaceholderValuesCreateResponse, CasesGenerateDocumentHtmlStreamCreateData, CasesGenerateDocumentHtmlStreamCreateResponse, CasesSendEmailCreateData, CasesSendEmailCreateResponse, CasesByAccessTokenRetrieveData, CasesByAccessTokenRetrieveResponse, CasesGenericDatamappersListData, CasesGenericDatamappersListResponse, CasesStateCountsRetrieveData, CasesStateCountsRetrieveResponse, ChatPreferencesListData, ChatPreferencesListResponse, ChatPreferencesCreateData, ChatPreferencesCreateResponse, ChatPreferencesRetrieveData, ChatPreferencesRetrieveResponse, ChatPreferencesUpdateData, ChatPreferencesUpdateResponse, ChatPreferencesPartialUpdateData, ChatPreferencesPartialUpdateResponse, ChatPreferencesDestroyData, ChatPreferencesDestroyResponse, ChatPreferencesDismissSuggestionCreateData, ChatPreferencesDismissSuggestionCreateResponse, ChatPreferencesGenerateTitleCreateData, ChatPreferencesGenerateTitleCreateResponse, ChatPreferencesSaveSuggestionCreateData, ChatPreferencesSaveSuggestionCreateResponse, DeliveryEventsListData, DeliveryEventsListResponse, DeliveryEventsCreateData, DeliveryEventsCreateResponse, DeliveryEventsRetrieveData, DeliveryEventsRetrieveResponse, DeliveryEventsUpdateData, DeliveryEventsUpdateResponse, DeliveryEventsPartialUpdateData, DeliveryEventsPartialUpdateResponse, DeliveryEventsDestroyData, DeliveryEventsDestroyResponse, DocumentPlaceholdersListData, DocumentPlaceholdersListResponse, DocumentPlaceholdersCreateData, DocumentPlaceholdersCreateResponse, DocumentPlaceholdersRetrieveData, DocumentPlaceholdersRetrieveResponse, DocumentPlaceholdersUpdateData, DocumentPlaceholdersUpdateResponse, DocumentPlaceholdersPartialUpdateData, DocumentPlaceholdersPartialUpdateResponse, DocumentPlaceholdersDestroyData, DocumentPlaceholdersDestroyResponse, DocumentPlaceholdersGenerateLabelsCreateData, DocumentPlaceholdersGenerateLabelsCreateResponse, DocumentTemplatesListData, DocumentTemplatesListResponse, DocumentTemplatesCreateData, DocumentTemplatesCreateResponse, DocumentTemplatesRetrieveData, DocumentTemplatesRetrieveResponse, DocumentTemplatesUpdateData, DocumentTemplatesUpdateResponse, DocumentTemplatesPartialUpdateData, DocumentTemplatesPartialUpdateResponse, DocumentTemplatesDestroyData, DocumentTemplatesDestroyResponse, DocumentTemplatesCopyCreateData, DocumentTemplatesCopyCreateResponse, DocumentsListData, DocumentsListResponse, DocumentsCreateData, DocumentsCreateResponse, DocumentsBulkSyncPlatformsCreateData, DocumentsBulkSyncPlatformsCreateResponse, DocumentsImportFromActaportCreateData, DocumentsImportFromActaportCreateResponse, DocumentsRefreshActaportDocumentsCreateData, DocumentsRefreshActaportDocumentsCreateResponse, DocumentsUploadCreateData, DocumentsUploadCreateResponse, DocumentsRetrieveData, DocumentsRetrieveResponse, DocumentsUpdateData, DocumentsUpdateResponse, DocumentsPartialUpdateData, DocumentsPartialUpdateResponse, DocumentsDestroyData, DocumentsDestroyResponse, DocumentsCreateEditTokenCreateData, DocumentsCreateEditTokenCreateResponse, DocumentsGenerateTitleCreateData, DocumentsGenerateTitleCreateResponse, DocumentsRetryProcessingCreateData, DocumentsRetryProcessingCreateResponse, DocumentsRevertToOriginalCreateData, DocumentsRevertToOriginalCreateResponse, DocumentsSendToActaportCreateData, DocumentsSendToActaportCreateResponse, DocumentsThumbnailsRetrieveData, DocumentsThumbnailsRetrieveResponse, DocumentsUploadModifiedCreateData, DocumentsUploadModifiedCreateResponse, DocumentsChatSessionGroupUploadCreateData, DocumentsChatSessionGroupUploadCreateResponse, DocumentsChatSessionUploadCreateData, DocumentsChatSessionUploadCreateResponse, DocumentsReorganizeCreateData, DocumentsReorganizeCreateResponse, DocumentsSplitWithAiCreateData, DocumentsSplitWithAiCreateResponse, DuplicateCaseMatchesListData, DuplicateCaseMatchesListResponse, DuplicateCaseMatchesCreateData, DuplicateCaseMatchesCreateResponse, DuplicateCaseMatchesRetrieveData, DuplicateCaseMatchesRetrieveResponse, DuplicateCaseMatchesUpdateData, DuplicateCaseMatchesUpdateResponse, DuplicateCaseMatchesPartialUpdateData, DuplicateCaseMatchesPartialUpdateResponse, DuplicateCaseMatchesDestroyData, DuplicateCaseMatchesDestroyResponse, DuplicateCaseMatchesForCaseListData, DuplicateCaseMatchesForCaseListResponse, EditorUploadCreateData, EditorUploadCreateResponse, EmailTemplatesListData, EmailTemplatesListResponse, EmailTemplatesCreateData, EmailTemplatesCreateResponse, EmailTemplatesRetrieveData, EmailTemplatesRetrieveResponse, EmailTemplatesUpdateData, EmailTemplatesUpdateResponse, EmailTemplatesPartialUpdateData, EmailTemplatesPartialUpdateResponse, EmailTemplatesDestroyData, EmailTemplatesDestroyResponse, EmailsListData, EmailsListResponse, EmailsCreateData, EmailsCreateResponse, EmailsRetrieveData, EmailsRetrieveResponse, EmailsUpdateData, EmailsUpdateResponse, EmailsPartialUpdateData, EmailsPartialUpdateResponse, EmailsDestroyData, EmailsDestroyResponse, EmailsRenderTemplateCreateData, EmailsRenderTemplateCreateResponse, EntitiesListData, EntitiesListResponse, EntitiesCreateData, EntitiesCreateResponse, EntitiesRetrieveData, EntitiesRetrieveResponse, EntitiesUpdateData, EntitiesUpdateResponse, EntitiesPartialUpdateData, EntitiesPartialUpdateResponse, EntitiesDestroyData, EntitiesDestroyResponse, EntitiesAddCaseDataRelationshipCreateData, EntitiesAddCaseDataRelationshipCreateResponse, EntitiesRemoveCaseDataRelationshipCreateData, EntitiesRemoveCaseDataRelationshipCreateResponse, EntitiesSwitchUniqueCaseDataRelationshipCreateData, EntitiesSwitchUniqueCaseDataRelationshipCreateResponse, EventCreateData, EventCreateResponse, EventsListData, EventsListResponse, EventsCreateData, EventsCreateResponse, EventsRetrieveData, EventsRetrieveResponse, EventsUpdateData, EventsUpdateResponse, EventsPartialUpdateData, EventsPartialUpdateResponse, EventsDestroyData, EventsDestroyResponse, EventsTrackCreateData, EventsTrackCreateResponse, FeatureFlagsCheckCreateData, FeatureFlagsCheckCreateResponse, FeatureFlagsCheckByAccessTokenCreateData, FeatureFlagsCheckByAccessTokenCreateResponse, FeedbackListData, FeedbackListResponse, FeedbackCreateData, FeedbackCreateResponse, FeedbackRetrieveData, FeedbackRetrieveResponse, FeedbackUpdateData, FeedbackUpdateResponse, FeedbackPartialUpdateData, FeedbackPartialUpdateResponse, FeedbackDestroyData, FeedbackDestroyResponse, FormsListData, FormsListResponse, FormsCreateData, FormsCreateResponse, FormsRetrieveData, FormsRetrieveResponse, FormsUpdateData, FormsUpdateResponse, FormsPartialUpdateData, FormsPartialUpdateResponse, FormsDestroyData, FormsDestroyResponse, FormsThirdPartyTokenRetrieveData, FormsThirdPartyTokenRetrieveResponse, FormsPdfFormRetrieveData, FormsPdfFormRetrieveResponse, FormsPdfFormSubmitCreateData, FormsPdfFormSubmitCreateResponse, FormsThirdPartyLinkCreateData, FormsThirdPartyLinkCreateResponse, HubspotCompaniesListData, HubspotCompaniesListResponse, HubspotCompaniesCreateResponse, HubspotCompaniesRetrieveData, HubspotCompaniesRetrieveResponse, HubspotCompaniesUpdateData, HubspotCompaniesUpdateResponse, HubspotCompaniesPartialUpdateData, HubspotCompaniesPartialUpdateResponse, HubspotCompaniesDestroyData, HubspotCompaniesDestroyResponse, HubspotCompaniesOnboardingDataRetrieveData, HubspotCompaniesOnboardingDataRetrieveResponse, HubspotCompaniesFindForOrganisationListData, HubspotCompaniesFindForOrganisationListResponse, HubspotContactsListData, HubspotContactsListResponse, HubspotContactsCreateResponse, HubspotContactsRetrieveData, HubspotContactsRetrieveResponse, HubspotContactsUpdateData, HubspotContactsUpdateResponse, HubspotContactsPartialUpdateData, HubspotContactsPartialUpdateResponse, HubspotContactsDestroyData, HubspotContactsDestroyResponse, InboundEmailsListData, InboundEmailsListResponse, InboundEmailsCreateData, InboundEmailsCreateResponse, InboundEmailsRetrieveData, InboundEmailsRetrieveResponse, InboundEmailsUpdateData, InboundEmailsUpdateResponse, InboundEmailsPartialUpdateData, InboundEmailsPartialUpdateResponse, InboundEmailsDestroyData, InboundEmailsDestroyResponse, InboundEmailsCreateCaseCreateData, InboundEmailsCreateCaseCreateResponse, JurnodesLawCategoriesListResponse, JurnodesRecordSchemasListResponse, JurnodesUsersListResponse, KleosCaseTypesRetrieveResponse, KleosOauthLogoutCreateResponse, LawFieldsRetrieveResponse, OnboardingPackagesListData, OnboardingPackagesListResponse, OnboardingPackagesCreateData, OnboardingPackagesCreateResponse, OnboardingPackagesRetrieveData, OnboardingPackagesRetrieveResponse, OnboardingPackagesUpdateData, OnboardingPackagesUpdateResponse, OnboardingPackagesPartialUpdateData, OnboardingPackagesPartialUpdateResponse, OnboardingPackagesDestroyData, OnboardingPackagesDestroyResponse, OnboardingSessionsStartFormCreateData, OnboardingSessionsStartFormCreateResponse, OnboardingSessionsStartQuestionnaireCreateData, OnboardingSessionsStartQuestionnaireCreateResponse, OnboardingSessionsByTokenRetrieveData, OnboardingSessionsByTokenRetrieveResponse, OnboardingSessionsCreateFromPackageCreateData, OnboardingSessionsCreateFromPackageCreateResponse, OrganisationsListData, OrganisationsListResponse, OrganisationsCreateData, OrganisationsCreateResponse, OrganisationsRetrieveData, OrganisationsRetrieveResponse, OrganisationsUpdateData, OrganisationsUpdateResponse, OrganisationsPartialUpdateData, OrganisationsPartialUpdateResponse, OrganisationsDestroyData, OrganisationsDestroyResponse, OrganisationsEmployeesListData, OrganisationsEmployeesListResponse, OrganisationsEmployeesRemoveCreateData, OrganisationsEmployeesRemoveCreateResponse, OrganisationsEmployeesCreateCreateData, OrganisationsEmployeesCreateCreateResponse, OrganisationsRunIntegrityCheckCreateData, OrganisationsRunIntegrityCheckCreateResponse, OrganisationsUpdateLogoCreateData, OrganisationsUpdateLogoCreateResponse, OrganisationsByOrgTokenRetrieveResponse, OrganisationsOrganisationsListListData, OrganisationsOrganisationsListListResponse, PdfFormSubmissionsListData, PdfFormSubmissionsListResponse, PdfFormSubmissionsCreateData, PdfFormSubmissionsCreateResponse, PdfFormSubmissionsRetrieveData, PdfFormSubmissionsRetrieveResponse, PdfFormSubmissionsUpdateData, PdfFormSubmissionsUpdateResponse, PdfFormSubmissionsPartialUpdateData, PdfFormSubmissionsPartialUpdateResponse, PdfFormSubmissionsDestroyData, PdfFormSubmissionsDestroyResponse, PdfFormSubmissionsByAccessTokenRetrieveData, PdfFormSubmissionsByAccessTokenRetrieveResponse, PdfFormSubmissionsExternalCreateData, PdfFormSubmissionsExternalCreateResponse, PdfFormTemplatesListData, PdfFormTemplatesListResponse, PdfFormTemplatesCreateData, PdfFormTemplatesCreateResponse, PdfFormTemplatesRetrieveData, PdfFormTemplatesRetrieveResponse, PdfFormTemplatesUpdateData, PdfFormTemplatesUpdateResponse, PdfFormTemplatesPartialUpdateData, PdfFormTemplatesPartialUpdateResponse, PdfFormTemplatesDestroyData, PdfFormTemplatesDestroyResponse, PdfFormTemplatesCopyCreateData, PdfFormTemplatesCopyCreateResponse, PdfFormTemplatesReplaceDocumentCreateData, PdfFormTemplatesReplaceDocumentCreateResponse, PhoneForwardingRulesListData, PhoneForwardingRulesListResponse, PhoneForwardingRulesCreateData, PhoneForwardingRulesCreateResponse, PhoneForwardingRulesRetrieveData, PhoneForwardingRulesRetrieveResponse, PhoneForwardingRulesUpdateData, PhoneForwardingRulesUpdateResponse, PhoneForwardingRulesPartialUpdateData, PhoneForwardingRulesPartialUpdateResponse, PhoneForwardingRulesDestroyData, PhoneForwardingRulesDestroyResponse, PhoneNumbersListData, PhoneNumbersListResponse, PhoneNumbersCreateData, PhoneNumbersCreateResponse, PhoneNumbersRetrieveData, PhoneNumbersRetrieveResponse, PhoneNumbersUpdateData, PhoneNumbersUpdateResponse, PhoneNumbersPartialUpdateData, PhoneNumbersPartialUpdateResponse, PhoneNumbersDestroyData, PhoneNumbersDestroyResponse, PlaceholdersListResponse, ProposedEntityChangesAcceptCreateData, ProposedEntityChangesAcceptCreateResponse, ProposedEntityChangesRejectCreateData, ProposedEntityChangesRejectCreateResponse, QuestionnaireSubmissionsListData, QuestionnaireSubmissionsListResponse, QuestionnaireSubmissionsCreateData, QuestionnaireSubmissionsCreateResponse, QuestionnaireSubmissionsRetrieveData, QuestionnaireSubmissionsRetrieveResponse, QuestionnaireSubmissionsUpdateData, QuestionnaireSubmissionsUpdateResponse, QuestionnaireSubmissionsPartialUpdateData, QuestionnaireSubmissionsPartialUpdateResponse, QuestionnaireSubmissionsDestroyData, QuestionnaireSubmissionsDestroyResponse, QuestionnaireSubmissionsDeleteFileDestroyData, QuestionnaireSubmissionsDeleteFileDestroyResponse, QuestionnaireSubmissionsUploadFileCreateData, QuestionnaireSubmissionsUploadFileCreateResponse, QuestionnaireSubmissionsCreateExternalCreateData, QuestionnaireSubmissionsCreateExternalCreateResponse, QuestionnairesListData, QuestionnairesListResponse, QuestionnairesCreateData, QuestionnairesCreateResponse, QuestionnairesRetrieveData, QuestionnairesRetrieveResponse, QuestionnairesUpdateData, QuestionnairesUpdateResponse, QuestionnairesPartialUpdateData, QuestionnairesPartialUpdateResponse, QuestionnairesDestroyData, QuestionnairesDestroyResponse, QuestionnairesCopyCreateData, QuestionnairesCopyCreateResponse, QuestionnairesGenerateCreateData, QuestionnairesGenerateCreateResponse, QuestionnairesGenerateTitleCreateData, QuestionnairesGenerateTitleCreateResponse, QuestionnairesThirdPartyCreateData, QuestionnairesThirdPartyCreateResponse, RetellAgentsListData, RetellAgentsListResponse, RetellAgentsCreateData, RetellAgentsCreateResponse, RetellAgentsRetrieveData, RetellAgentsRetrieveResponse, RetellAgentsUpdateData, RetellAgentsUpdateResponse, RetellAgentsPartialUpdateData, RetellAgentsPartialUpdateResponse, RetellAgentsDestroyData, RetellAgentsDestroyResponse, SavedResponsesListData, SavedResponsesListResponse, SavedResponsesCreateData, SavedResponsesCreateResponse, SavedResponsesRetrieveData, SavedResponsesRetrieveResponse, SavedResponsesUpdateData, SavedResponsesUpdateResponse, SavedResponsesPartialUpdateData, SavedResponsesPartialUpdateResponse, SavedResponsesDestroyData, SavedResponsesDestroyResponse, SavedResponsesGenerateTitleCreateData, SavedResponsesGenerateTitleCreateResponse, ServicesListData, ServicesListResponse, ServicesCreateData, ServicesCreateResponse, ServicesRetrieveData, ServicesRetrieveResponse, ServicesUpdateData, ServicesUpdateResponse, ServicesPartialUpdateData, ServicesPartialUpdateResponse, ServicesDestroyData, ServicesDestroyResponse, ServicesAvailabilitiesCreateData, ServicesAvailabilitiesCreateResponse, SettingsActaportListResponse, SettingsActaportCreateData, SettingsActaportCreateResponse, SettingsActaportSyncUpdateResponse, SettingsAdvoluxListResponse, SettingsAdvoluxCreateData, SettingsAdvoluxCreateResponse, SettingsAdvowareListResponse, SettingsAdvowareCreateData, SettingsAdvowareCreateResponse, SettingsAdvowareSyncUpdateResponse, SettingsEmailEgressListResponse, SettingsEmailEgressCreateData, SettingsEmailEgressCreateResponse, SettingsHibpListResponse, SettingsHibpCreateData, SettingsHibpCreateResponse, SettingsHubspotListResponse, SettingsHubspotCreateData, SettingsHubspotCreateResponse, SettingsIustaListResponse, SettingsIustaCreateData, SettingsIustaCreateResponse, SettingsJurnodesListResponse, SettingsJurnodesCreateData, SettingsJurnodesCreateResponse, SettingsJurnodesSyncUpdateResponse, SettingsKleosListResponse, SettingsKleosCreateData, SettingsKleosCreateResponse, SettingsLawfirmListResponse, SettingsLawfirmCreateData, SettingsLawfirmCreateResponse, SettingsWebhooksListResponse, SettingsWebhooksCreateData, SettingsWebhooksCreateResponse, StaleDocumentsListData, StaleDocumentsListResponse, StaleDocumentsCreateData, StaleDocumentsCreateResponse, StaleDocumentsRetrieveData, StaleDocumentsRetrieveResponse, StaleDocumentsUpdateData, StaleDocumentsUpdateResponse, StaleDocumentsPartialUpdateData, StaleDocumentsPartialUpdateResponse, StaleDocumentsDestroyData, StaleDocumentsDestroyResponse, StaleDocumentsMarkCompletedCreateData, StaleDocumentsMarkCompletedCreateResponse, StaleDocumentsMarkFailedCreateData, StaleDocumentsMarkFailedCreateResponse, StaleDocumentsRetryProcessingCreateData, StaleDocumentsRetryProcessingCreateResponse, StripeCustomersListData, StripeCustomersListResponse, StripeCustomersCreateData, StripeCustomersCreateResponse, StripeCustomersRetrieveData, StripeCustomersRetrieveResponse, StripeCustomersUpdateData, StripeCustomersUpdateResponse, StripeCustomersPartialUpdateData, StripeCustomersPartialUpdateResponse, StripeCustomersDestroyData, StripeCustomersDestroyResponse, StripeCustomersFindForOrganisationListData, StripeCustomersFindForOrganisationListResponse, StripeInvoicesListData, StripeInvoicesListResponse, StripeInvoicesCreateData, StripeInvoicesCreateResponse, StripeInvoicesRetrieveData, StripeInvoicesRetrieveResponse, StripeInvoicesUpdateData, StripeInvoicesUpdateResponse, StripeInvoicesPartialUpdateData, StripeInvoicesPartialUpdateResponse, StripeInvoicesDestroyData, StripeInvoicesDestroyResponse, StripeInvoicesExportCreateData, StripeInvoicesExportCreateResponse, StripeSubscriptionsListData, StripeSubscriptionsListResponse, StripeSubscriptionsCreateResponse, StripeSubscriptionsRetrieveData, StripeSubscriptionsRetrieveResponse, StripeSubscriptionsUpdateData, StripeSubscriptionsUpdateResponse, StripeSubscriptionsPartialUpdateData, StripeSubscriptionsPartialUpdateResponse, StripeSubscriptionsDestroyData, StripeSubscriptionsDestroyResponse, UnifiedDocumentTemplatesListData, UnifiedDocumentTemplatesListResponse, UnifiedDocumentTemplatesPartialUpdateData, UnifiedDocumentTemplatesPartialUpdateResponse, UnifiedDocumentTemplatesDestroyData, UnifiedDocumentTemplatesDestroyResponse, UnifiedDocumentTemplatesThirdPartyTokenRetrieveData, UnifiedDocumentTemplatesThirdPartyTokenRetrieveResponse, UsersListData, UsersListResponse, UsersCreateData, UsersCreateResponse, UsersRetrieveData, UsersRetrieveResponse, UsersUpdateData, UsersUpdateResponse, UsersPartialUpdateData, UsersPartialUpdateResponse, UsersDestroyData, UsersDestroyResponse, UsersAdminPasswordUpdatePartialUpdateData, UsersAdminPasswordUpdatePartialUpdateResponse, UsersUpdateAvatarCreateData, UsersUpdateAvatarCreateResponse, UsersChangePasswordCreateData, UsersChangePasswordCreateResponse, WordDocumentTemplatesListData, WordDocumentTemplatesListResponse, WordDocumentTemplatesCreateData, WordDocumentTemplatesCreateResponse, WordDocumentTemplatesRetrieveData, WordDocumentTemplatesRetrieveResponse, WordDocumentTemplatesUpdateData, WordDocumentTemplatesUpdateResponse, WordDocumentTemplatesPartialUpdateData, WordDocumentTemplatesPartialUpdateResponse, WordDocumentTemplatesDestroyData, WordDocumentTemplatesDestroyResponse, WordDocumentTemplatesCopyCreateData, WordDocumentTemplatesCopyCreateResponse, WordDocumentTemplatesCopyAiToCurrentCreateData, WordDocumentTemplatesCopyAiToCurrentCreateResponse, WordDocumentTemplatesCreateEditTokenCreateData, WordDocumentTemplatesCreateEditTokenCreateResponse, WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateData, WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateResponse, WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateData, WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateResponse, WordDocumentTemplatesDeleteDocumentCreateData, WordDocumentTemplatesDeleteDocumentCreateResponse, WordDocumentTemplatesExtractMetadataCreateData, WordDocumentTemplatesExtractMetadataCreateResponse, WordDocumentTemplatesResetToOriginalCreateData, WordDocumentTemplatesResetToOriginalCreateResponse, WordDocumentTemplatesValidateRetrieveData, WordDocumentTemplatesValidateRetrieveResponse, WordDocumentTemplatesValidateCreateData, WordDocumentTemplatesValidateCreateResponse, WordDocumentTemplatesValidatePartialUpdateData, WordDocumentTemplatesValidatePartialUpdateResponse, WordDocumentTemplatesBulkUploadCreateData, WordDocumentTemplatesBulkUploadCreateResponse, WordDocumentTemplatesTaskStatusRetrieveData, WordDocumentTemplatesTaskStatusRetrieveResponse } from './types.gen';

export class AccountsService {
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAccountList
     * @throws ApiError
     */
    public static accountsList(data: AccountsListData = {}): CancelablePromise<AccountsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/accounts/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAccount
     * @throws ApiError
     */
    public static accountsCreate(data: AccountsCreateData = {}): CancelablePromise<AccountsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/accounts/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAccount
     * @throws ApiError
     */
    public static accountsRetrieve(data: AccountsRetrieveData): CancelablePromise<AccountsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/accounts/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAccount
     * @throws ApiError
     */
    public static accountsUpdate(data: AccountsUpdateData): CancelablePromise<AccountsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/accounts/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAccount
     * @throws ApiError
     */
    public static accountsPartialUpdate(data: AccountsPartialUpdateData): CancelablePromise<AccountsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/accounts/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAccount
     * @throws ApiError
     */
    public static accountsDestroy(data: AccountsDestroyData): CancelablePromise<AccountsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/accounts/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing accounts related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAccount
     * @throws ApiError
     */
    public static accountsAvailabilityTokenRetrieve(data: AccountsAvailabilityTokenRetrieveData): CancelablePromise<AccountsAvailabilityTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/accounts/{uuid}/availability_token/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class ActaportCollisionsService {
    /**
     * Check for potential conflicts of interest via Actaport
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns ActaportCollisionResponse
     * @throws ApiError
     */
    public static actaportCollisionsCollisionsCreate(data: ActaportCollisionsCollisionsCreateData): CancelablePromise<ActaportCollisionsCollisionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/actaport_collisions/{id}/collisions/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                500: ''
            }
        });
    }
    
}

export class ActaportPartyMatchingService {
    /**
     * Find potential Actaport contact matches for case participants
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ActaportPartyMatchingResponse
     * @throws ApiError
     */
    public static actaportPartyMatchingFindMatchesCreate(data: ActaportPartyMatchingFindMatchesCreateData): CancelablePromise<ActaportPartyMatchingFindMatchesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/actaport_party_matching/find-matches/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
}

export class ActionAutoCommitSettingsService {
    /**
     * An API endpoint for viewing and editing action auto commit settings.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTActionAutoCommitSettingsList
     * @throws ApiError
     */
    public static actionAutoCommitSettingsList(data: ActionAutoCommitSettingsListData = {}): CancelablePromise<ActionAutoCommitSettingsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/action_auto_commit_settings/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing action auto commit settings.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TActionAutoCommitSettings
     * @throws ApiError
     */
    public static actionAutoCommitSettingsCreate(data: ActionAutoCommitSettingsCreateData = {}): CancelablePromise<ActionAutoCommitSettingsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/action_auto_commit_settings/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing action auto commit settings.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TActionAutoCommitSettings
     * @throws ApiError
     */
    public static actionAutoCommitSettingsRetrieve(data: ActionAutoCommitSettingsRetrieveData): CancelablePromise<ActionAutoCommitSettingsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/action_auto_commit_settings/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing action auto commit settings.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TActionAutoCommitSettings
     * @throws ApiError
     */
    public static actionAutoCommitSettingsUpdate(data: ActionAutoCommitSettingsUpdateData): CancelablePromise<ActionAutoCommitSettingsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/action_auto_commit_settings/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing action auto commit settings.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TActionAutoCommitSettings
     * @throws ApiError
     */
    public static actionAutoCommitSettingsPartialUpdate(data: ActionAutoCommitSettingsPartialUpdateData): CancelablePromise<ActionAutoCommitSettingsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/action_auto_commit_settings/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing action auto commit settings.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TActionAutoCommitSettings
     * @throws ApiError
     */
    public static actionAutoCommitSettingsDestroy(data: ActionAutoCommitSettingsDestroyData): CancelablePromise<ActionAutoCommitSettingsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/action_auto_commit_settings/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get available auto commit actions
     * Returns all available auto commit settings from loaded actions that can be configured.
     * @returns unknown No response body
     * @throws ApiError
     */
    public static actionAutoCommitSettingsAvailableActionsRetrieve(): CancelablePromise<ActionAutoCommitSettingsAvailableActionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/action_auto_commit_settings/available-actions/'
        });
    }
    
}

export class ActivitiesService {
    /**
     * List activities with search support.
     * @param data The data for the request.
     * @param data.activityType
     * @param data._case
     * @param data.clerk
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search Search activities by client name, client email, company name, document title, questionnaire title, or email sender
     * @param data.state * `ALL` - All activities
     * * `UNSEEN` - Unseen activities
     * @returns PaginatedTActivityList
     * @throws ApiError
     */
    public static activitiesList(data: ActivitiesListData = {}): CancelablePromise<ActivitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/activities/',
            query: {
                activity_type: data.activityType,
                case: data._case,
                clerk: data.clerk,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                state: data.state
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing activities.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesCreate(data: ActivitiesCreateData = {}): CancelablePromise<ActivitiesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/activities/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing activities.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesRetrieve(data: ActivitiesRetrieveData): CancelablePromise<ActivitiesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/activities/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing activities.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesUpdate(data: ActivitiesUpdateData): CancelablePromise<ActivitiesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/activities/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing activities.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesPartialUpdate(data: ActivitiesPartialUpdateData): CancelablePromise<ActivitiesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/activities/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing activities.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesDestroy(data: ActivitiesDestroyData): CancelablePromise<ActivitiesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/activities/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Mark an activity as seen.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesMarkSeenCreate(data: ActivitiesMarkSeenCreateData): CancelablePromise<ActivitiesMarkSeenCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/activities/{uuid}/mark-seen/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Mark an activity as unseen.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TActivity
     * @throws ApiError
     */
    public static activitiesMarkUnseenCreate(data: ActivitiesMarkUnseenCreateData): CancelablePromise<ActivitiesMarkUnseenCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/activities/{uuid}/mark-unseen/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get the count of unseen activities.
     * @returns unknown
     * @throws ApiError
     */
    public static activitiesUnseenCountRetrieve(): CancelablePromise<ActivitiesUnseenCountRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/activities/unseen-count/'
        });
    }
    
}

export class AdvowareRolesService {
    /**
     * ViewSet for Advoware role operations.
     *
     * Provides endpoint to preview how entity roles will be mapped to Advoware roles before export.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdvowareRoleMapping
     * @throws ApiError
     */
    public static advowareRolesGetRoleMappingsCreate(data: AdvowareRolesGetRoleMappingsCreateData): CancelablePromise<AdvowareRolesGetRoleMappingsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/advoware_roles/get-role-mappings/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class AgentActionsService {
    /**
     * An API endpoint for viewing and editing AgentActions.
     * @param data The data for the request.
     * @param data.actionType * `DRAFT_WORD_DOCUMENT_TEMPLATE` - Draft Word Document Template
     * * `CASE_ASSIGN_LIFECYCLE_WORKFLOW` - Case Assign Lifecycle Workflow
     * * `SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT` - Send Appointment Booking Link To Client
     * * `SEND_CLIENT_TEMPLATE_EMAIL` - Send Client Template Email
     * * `CASE_ASSIGN_LAWYER` - Case Assign Lawyer
     * * `CASE_ASSIGN_LAW_DOMAIN` - Case Assign Law Domain
     * * `CASE_ASSIGN_STATUS` - Case Assign Status
     * @param data.agent
     * @param data.callingAgent
     * @param data.caseUuid
     * @param data.deliveryMode * `RECOMMENDATION` - Recommendation
     * * `AUTO_COMMIT` - Auto Commit
     * @param data.hasCommitError
     * @param data.hasRevertError
     * @param data.isCommitted
     * @param data.isReverted
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @returns PaginatedTAgentActionList
     * @throws ApiError
     */
    public static agentActionsList(data: AgentActionsListData = {}): CancelablePromise<AgentActionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/agent_actions/',
            query: {
                action_type: data.actionType,
                agent: data.agent,
                calling_agent: data.callingAgent,
                case__uuid: data.caseUuid,
                delivery_mode: data.deliveryMode,
                has_commit_error: data.hasCommitError,
                has_revert_error: data.hasRevertError,
                is_committed: data.isCommitted,
                is_reverted: data.isReverted,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AgentActions.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAgentAction
     * @throws ApiError
     */
    public static agentActionsCreate(data: AgentActionsCreateData = {}): CancelablePromise<AgentActionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/agent_actions/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AgentActions.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAgentAction
     * @throws ApiError
     */
    public static agentActionsRetrieve(data: AgentActionsRetrieveData): CancelablePromise<AgentActionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/agent_actions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AgentActions.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAgentAction
     * @throws ApiError
     */
    public static agentActionsUpdate(data: AgentActionsUpdateData): CancelablePromise<AgentActionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/agent_actions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AgentActions.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAgentAction
     * @throws ApiError
     */
    public static agentActionsPartialUpdate(data: AgentActionsPartialUpdateData): CancelablePromise<AgentActionsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/agent_actions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AgentActions.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAgentAction
     * @throws ApiError
     */
    public static agentActionsDestroy(data: AgentActionsDestroyData): CancelablePromise<AgentActionsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/agent_actions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get advisory for case acceptance instructions
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CaseCreateInstructionsAdvisoryResponse
     * @throws ApiError
     */
    public static agentActionsCaseCreateInstructionsAdvisoryCreate(data: AgentActionsCaseCreateInstructionsAdvisoryCreateData): CancelablePromise<AgentActionsCaseCreateInstructionsAdvisoryCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/agent_actions/case-create-instructions-advisory/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                500: ''
            }
        });
    }
    
    /**
     * Commit an agent action by UUID
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static agentActionsCommitCreate(data: AgentActionsCommitCreateData): CancelablePromise<AgentActionsCommitCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/agent_actions/commit/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Rate an agent action by UUID
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static agentActionsRateCreate(data: AgentActionsRateCreateData): CancelablePromise<AgentActionsRateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/agent_actions/rate/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Revert an agent action by UUID
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static agentActionsRevertCreate(data: AgentActionsRevertCreateData): CancelablePromise<AgentActionsRevertCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/agent_actions/revert/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                404: ''
            }
        });
    }
    
}

export class AiAnalysisService {
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAiAnalysisList
     * @throws ApiError
     */
    public static aiAnalysisList(data: AiAnalysisListData = {}): CancelablePromise<AiAnalysisListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_analysis/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAiAnalysis
     * @throws ApiError
     */
    public static aiAnalysisCreate(data: AiAnalysisCreateData = {}): CancelablePromise<AiAnalysisCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_analysis/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAiAnalysis
     * @throws ApiError
     */
    public static aiAnalysisRetrieve(data: AiAnalysisRetrieveData): CancelablePromise<AiAnalysisRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_analysis/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiAnalysis
     * @throws ApiError
     */
    public static aiAnalysisUpdate(data: AiAnalysisUpdateData): CancelablePromise<AiAnalysisUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/ai_analysis/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiAnalysis
     * @throws ApiError
     */
    public static aiAnalysisPartialUpdate(data: AiAnalysisPartialUpdateData): CancelablePromise<AiAnalysisPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/ai_analysis/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAiAnalysis
     * @throws ApiError
     */
    public static aiAnalysisDestroy(data: AiAnalysisDestroyData): CancelablePromise<AiAnalysisDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/ai_analysis/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Return all AI analyses for a given document UUID.
     * @param data The data for the request.
     * @param data.documentUuid
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAiAnalysisList
     * @throws ApiError
     */
    public static aiAnalysisByDocumentUuidList(data: AiAnalysisByDocumentUuidListData): CancelablePromise<AiAnalysisByDocumentUuidListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_analysis/by-document-uuid/{document_uuid}/',
            path: {
                document_uuid: data.documentUuid
            },
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
}

export class AiAugmentationService {
    /**
     * An API endpoint for viewing and editing AI augmentations.
     * @param data The data for the request.
     * @param data.augmentationVariant * `DOCUMENT ANALYSIS` - Document Analysis
     * * `EMAIL EXTRACTION` - Email Extraction
     * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
     * * `UNIVERSAL ENTITY EXTRACTION` - Universal Entity Extraction
     * * `CALL` - Call
     * * `CHATBOT` - Chatbot
     * * `AGENT` - Agent
     * @param data.caseUuid
     * @param data.documentUuid
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAiAugmentationList
     * @throws ApiError
     */
    public static aiAugmentationList(data: AiAugmentationListData = {}): CancelablePromise<AiAugmentationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_augmentation/',
            query: {
                augmentation_variant: data.augmentationVariant,
                case__uuid: data.caseUuid,
                document__uuid: data.documentUuid,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI augmentations.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAiAugmentation
     * @throws ApiError
     */
    public static aiAugmentationCreate(data: AiAugmentationCreateData = {}): CancelablePromise<AiAugmentationCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_augmentation/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI augmentations.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAiAugmentation
     * @throws ApiError
     */
    public static aiAugmentationRetrieve(data: AiAugmentationRetrieveData): CancelablePromise<AiAugmentationRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_augmentation/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI augmentations.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiAugmentation
     * @throws ApiError
     */
    public static aiAugmentationUpdate(data: AiAugmentationUpdateData): CancelablePromise<AiAugmentationUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/ai_augmentation/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI augmentations.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiAugmentation
     * @throws ApiError
     */
    public static aiAugmentationPartialUpdate(data: AiAugmentationPartialUpdateData): CancelablePromise<AiAugmentationPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/ai_augmentation/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI augmentations.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAiAugmentation
     * @throws ApiError
     */
    public static aiAugmentationDestroy(data: AiAugmentationDestroyData): CancelablePromise<AiAugmentationDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/ai_augmentation/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Return all AI augmentations for a given document UUID.
     * @param data The data for the request.
     * @param data.documentUuid
     * @param data.augmentationVariant * `DOCUMENT ANALYSIS` - Document Analysis
     * * `EMAIL EXTRACTION` - Email Extraction
     * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
     * * `UNIVERSAL ENTITY EXTRACTION` - Universal Entity Extraction
     * * `CALL` - Call
     * * `CHATBOT` - Chatbot
     * * `AGENT` - Agent
     * @param data.caseUuid
     * @param data.documentUuid
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAiAugmentationList
     * @throws ApiError
     */
    public static aiAugmentationByDocumentUuidList(data: AiAugmentationByDocumentUuidListData): CancelablePromise<AiAugmentationByDocumentUuidListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_augmentation/by-document-uuid/{document_uuid}/',
            path: {
                document_uuid: data.documentUuid
            },
            query: {
                augmentation_variant: data.augmentationVariant,
                case__uuid: data.caseUuid,
                document__uuid: data.documentUuid,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
}

export class AiChatQuestionTemplatesService {
    /**
     * An API endpoint for viewing and editing AiChatQuestionTemplates.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAiChatQuestionTemplateList
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesList(data: AiChatQuestionTemplatesListData = {}): CancelablePromise<AiChatQuestionTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_question_templates/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AiChatQuestionTemplates.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesCreate(data: AiChatQuestionTemplatesCreateData = {}): CancelablePromise<AiChatQuestionTemplatesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_question_templates/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AiChatQuestionTemplates.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesRetrieve(data: AiChatQuestionTemplatesRetrieveData): CancelablePromise<AiChatQuestionTemplatesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_question_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AiChatQuestionTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesUpdate(data: AiChatQuestionTemplatesUpdateData): CancelablePromise<AiChatQuestionTemplatesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/ai_chat_question_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AiChatQuestionTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesPartialUpdate(data: AiChatQuestionTemplatesPartialUpdateData): CancelablePromise<AiChatQuestionTemplatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/ai_chat_question_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AiChatQuestionTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesDestroy(data: AiChatQuestionTemplatesDestroyData): CancelablePromise<AiChatQuestionTemplatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/ai_chat_question_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Copy a specific instance of a document template.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesCopyCreate(data: AiChatQuestionTemplatesCopyCreateData): CancelablePromise<AiChatQuestionTemplatesCopyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_question_templates/{uuid}/copy/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Mark a template as favorite for the current user.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesFavoriteCreate(data: AiChatQuestionTemplatesFavoriteCreateData): CancelablePromise<AiChatQuestionTemplatesFavoriteCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_question_templates/{uuid}/favorite/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Remove a template from the current user's favorites.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesUnfavoriteCreate(data: AiChatQuestionTemplatesUnfavoriteCreateData): CancelablePromise<AiChatQuestionTemplatesUnfavoriteCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_question_templates/{uuid}/unfavorite/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Generate a description for an AI chat question template based on the prompt, law field, and law topic.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAiChatQuestionTemplate
     * @throws ApiError
     */
    public static aiChatQuestionTemplatesGenerateDescriptionCreate(data: AiChatQuestionTemplatesGenerateDescriptionCreateData = {}): CancelablePromise<AiChatQuestionTemplatesGenerateDescriptionCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_question_templates/generate-description/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class AiChatSessionGroupsService {
    /**
     * ViewSet for managing AI chat session groups (folders).
     *
     * Session groups are used to organize global AI chat sessions into logical folders.
     * Each group can have custom instructions and documents that apply to all sessions in the group.
     * @param data The data for the request.
     * @param data.createdByUser
     * @param data.limit Number of results to return per page.
     * @param data.name
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedSessionGroupList
     * @throws ApiError
     */
    public static aiChatSessionGroupsList(data: AiChatSessionGroupsListData = {}): CancelablePromise<AiChatSessionGroupsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_session_groups/',
            query: {
                created_by_user: data.createdByUser,
                limit: data.limit,
                name: data.name,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * ViewSet for managing AI chat session groups (folders).
     *
     * Session groups are used to organize global AI chat sessions into logical folders.
     * Each group can have custom instructions and documents that apply to all sessions in the group.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SessionGroup
     * @throws ApiError
     */
    public static aiChatSessionGroupsCreate(data: AiChatSessionGroupsCreateData): CancelablePromise<AiChatSessionGroupsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_session_groups/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing AI chat session groups (folders).
     *
     * Session groups are used to organize global AI chat sessions into logical folders.
     * Each group can have custom instructions and documents that apply to all sessions in the group.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns SessionGroup
     * @throws ApiError
     */
    public static aiChatSessionGroupsRetrieve(data: AiChatSessionGroupsRetrieveData): CancelablePromise<AiChatSessionGroupsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_session_groups/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * ViewSet for managing AI chat session groups (folders).
     *
     * Session groups are used to organize global AI chat sessions into logical folders.
     * Each group can have custom instructions and documents that apply to all sessions in the group.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns SessionGroup
     * @throws ApiError
     */
    public static aiChatSessionGroupsUpdate(data: AiChatSessionGroupsUpdateData): CancelablePromise<AiChatSessionGroupsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/ai_chat_session_groups/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing AI chat session groups (folders).
     *
     * Session groups are used to organize global AI chat sessions into logical folders.
     * Each group can have custom instructions and documents that apply to all sessions in the group.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns SessionGroup
     * @throws ApiError
     */
    public static aiChatSessionGroupsPartialUpdate(data: AiChatSessionGroupsPartialUpdateData): CancelablePromise<AiChatSessionGroupsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/ai_chat_session_groups/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing AI chat session groups (folders).
     *
     * Session groups are used to organize global AI chat sessions into logical folders.
     * Each group can have custom instructions and documents that apply to all sessions in the group.
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static aiChatSessionGroupsDestroy(data: AiChatSessionGroupsDestroyData): CancelablePromise<AiChatSessionGroupsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/ai_chat_session_groups/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get all chat sessions in this session group.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SessionGroup
     * @throws ApiError
     */
    public static aiChatSessionGroupsChatSessionsRetrieve(data: AiChatSessionGroupsChatSessionsRetrieveData): CancelablePromise<AiChatSessionGroupsChatSessionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_session_groups/{uuid}/chat_sessions/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Create a new chat session in this session group.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns SessionGroup
     * @throws ApiError
     */
    public static aiChatSessionGroupsCreateChatSessionCreate(data: AiChatSessionGroupsCreateChatSessionCreateData): CancelablePromise<AiChatSessionGroupsCreateChatSessionCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_session_groups/{uuid}/create_chat_session/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class AiChatSessionsService {
    /**
     * An API endpoint for viewing and editing AIChatSessions.
     * @param data The data for the request.
     * @param data.endDate Created before (inclusive)
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search Search in message content
     * @param data.searchRoles Roles to search in (comma-separated)
     * @param data.sessionGroup
     * @param data.sessionType Type of chat session - GLOBAL or CASE
     *
     * * `GLOBAL` - Global
     * * `CASE` - Case
     * @param data.startDate Created after
     * @returns PaginatedTAIChatSessionList
     * @throws ApiError
     */
    public static aiChatSessionsList(data: AiChatSessionsListData = {}): CancelablePromise<AiChatSessionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_sessions/',
            query: {
                end_date: data.endDate,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                search_roles: data.searchRoles,
                session_group: data.sessionGroup,
                session_type: data.sessionType,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AIChatSessions.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAIChatSession
     * @throws ApiError
     */
    public static aiChatSessionsCreate(data: AiChatSessionsCreateData = {}): CancelablePromise<AiChatSessionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_sessions/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AIChatSessions.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAIChatSession
     * @throws ApiError
     */
    public static aiChatSessionsRetrieve(data: AiChatSessionsRetrieveData): CancelablePromise<AiChatSessionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_chat_sessions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AIChatSessions.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAIChatSession
     * @throws ApiError
     */
    public static aiChatSessionsUpdate(data: AiChatSessionsUpdateData): CancelablePromise<AiChatSessionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/ai_chat_sessions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AIChatSessions.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAIChatSession
     * @throws ApiError
     */
    public static aiChatSessionsPartialUpdate(data: AiChatSessionsPartialUpdateData): CancelablePromise<AiChatSessionsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/ai_chat_sessions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AIChatSessions.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAIChatSession
     * @throws ApiError
     */
    public static aiChatSessionsDestroy(data: AiChatSessionsDestroyData): CancelablePromise<AiChatSessionsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/ai_chat_sessions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Export the chat session as a PDF and optionally attach it to the case.
     * If attach_to_case is False, the PDF content is returned directly in the response
     * without creating a Document object in the database.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAIChatSession
     * @throws ApiError
     */
    public static aiChatSessionsExportPdfCreate(data: AiChatSessionsExportPdfCreateData): CancelablePromise<AiChatSessionsExportPdfCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_sessions/{uuid}/export_pdf/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Send a message to the AI chat session.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns AIChatSessionSendMessageResponse
     * @throws ApiError
     */
    public static aiChatSessionsSendMessageCreate(data: AiChatSessionsSendMessageCreateData): CancelablePromise<AiChatSessionsSendMessageCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_sessions/{uuid}/send_message/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Enhance a prompt to make it more effective for legal AI assistance.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AIChatSessionEnhancePromptResponse
     * @throws ApiError
     */
    public static aiChatSessionsEnhancePromptCreate(data: AiChatSessionsEnhancePromptCreateData): CancelablePromise<AiChatSessionsEnhancePromptCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_chat_sessions/enhance_prompt/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class AiSettingsService {
    /**
     * An API endpoint for viewing and editing AI settings.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAiSettingsList
     * @throws ApiError
     */
    public static aiSettingsList(data: AiSettingsListData = {}): CancelablePromise<AiSettingsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_settings/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI settings.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAiSettings
     * @throws ApiError
     */
    public static aiSettingsCreate(data: AiSettingsCreateData = {}): CancelablePromise<AiSettingsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/ai_settings/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI settings.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAiSettings
     * @throws ApiError
     */
    public static aiSettingsRetrieve(data: AiSettingsRetrieveData): CancelablePromise<AiSettingsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_settings/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI settings.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiSettings
     * @throws ApiError
     */
    public static aiSettingsUpdate(data: AiSettingsUpdateData): CancelablePromise<AiSettingsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/ai_settings/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI settings.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAiSettings
     * @throws ApiError
     */
    public static aiSettingsPartialUpdate(data: AiSettingsPartialUpdateData): CancelablePromise<AiSettingsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/ai_settings/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing AI settings.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAiSettings
     * @throws ApiError
     */
    public static aiSettingsDestroy(data: AiSettingsDestroyData): CancelablePromise<AiSettingsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/ai_settings/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get available auto commit actions
     * Returns all available auto commit settings from loaded actions that can be configured.
     * @returns unknown No response body
     * @throws ApiError
     */
    public static aiSettingsAvailableActionsRetrieve(): CancelablePromise<AiSettingsAvailableActionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_settings/available-actions/'
        });
    }
    
    /**
     * Get available notification actions
     * Returns all available notification settings from loaded actions that can be configured.
     * @returns NotificationSettings
     * @throws ApiError
     */
    public static aiSettingsAvailableNotificationActionsRetrieve(): CancelablePromise<AiSettingsAvailableNotificationActionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/ai_settings/available-notification-actions/'
        });
    }
    
}

export class AnnouncementsService {
    /**
     * API endpoint for viewing and managing sitewide announcements.
     *
     * Regular authenticated users can view active announcements.
     * Superusers can create, update, and delete announcements.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAnnouncementList
     * @throws ApiError
     */
    public static announcementsList(data: AnnouncementsListData = {}): CancelablePromise<AnnouncementsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/announcements/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * API endpoint for viewing and managing sitewide announcements.
     *
     * Regular authenticated users can view active announcements.
     * Superusers can create, update, and delete announcements.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAnnouncement
     * @throws ApiError
     */
    public static announcementsCreate(data: AnnouncementsCreateData = {}): CancelablePromise<AnnouncementsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/announcements/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for viewing and managing sitewide announcements.
     *
     * Regular authenticated users can view active announcements.
     * Superusers can create, update, and delete announcements.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAnnouncement
     * @throws ApiError
     */
    public static announcementsRetrieve(data: AnnouncementsRetrieveData): CancelablePromise<AnnouncementsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/announcements/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * API endpoint for viewing and managing sitewide announcements.
     *
     * Regular authenticated users can view active announcements.
     * Superusers can create, update, and delete announcements.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAnnouncement
     * @throws ApiError
     */
    public static announcementsUpdate(data: AnnouncementsUpdateData): CancelablePromise<AnnouncementsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/announcements/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for viewing and managing sitewide announcements.
     *
     * Regular authenticated users can view active announcements.
     * Superusers can create, update, and delete announcements.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAnnouncement
     * @throws ApiError
     */
    public static announcementsPartialUpdate(data: AnnouncementsPartialUpdateData): CancelablePromise<AnnouncementsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/announcements/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for viewing and managing sitewide announcements.
     *
     * Regular authenticated users can view active announcements.
     * Superusers can create, update, and delete announcements.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAnnouncement
     * @throws ApiError
     */
    public static announcementsDestroy(data: AnnouncementsDestroyData): CancelablePromise<AnnouncementsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/announcements/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Permanently dismiss announcement. The announcement will never be shown again to this user.
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static announcementsDismissCreate(data: AnnouncementsDismissCreateData): CancelablePromise<AnnouncementsDismissCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/announcements/{uuid}/dismiss/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Hide announcement until next login. The announcement will reappear after the user logs in again.
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static announcementsHideCreate(data: AnnouncementsHideCreateData): CancelablePromise<AnnouncementsHideCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/announcements/{uuid}/hide/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get all currently active announcements.
     *
     * This endpoint returns announcements that are active and within
     * their date range (if specified). Publicly accessible without authentication.
     *
     * :param request: HTTP request
     * :return: Response with active announcements
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTActiveAnnouncementList
     * @throws ApiError
     */
    public static announcementsActiveList(data: AnnouncementsActiveListData = {}): CancelablePromise<AnnouncementsActiveListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/announcements/active/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
}

export class AppointmentProposalsService {
    /**
     * An API endpoint for viewing and editing appointment proposals.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAppointmentProposalList
     * @throws ApiError
     */
    public static appointmentProposalsList(data: AppointmentProposalsListData = {}): CancelablePromise<AppointmentProposalsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/appointment_proposals/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointment proposals.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAppointmentProposal
     * @throws ApiError
     */
    public static appointmentProposalsCreate(data: AppointmentProposalsCreateData = {}): CancelablePromise<AppointmentProposalsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/appointment_proposals/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointment proposals.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAppointmentProposal
     * @throws ApiError
     */
    public static appointmentProposalsRetrieve(data: AppointmentProposalsRetrieveData): CancelablePromise<AppointmentProposalsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/appointment_proposals/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointment proposals.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAppointmentProposal
     * @throws ApiError
     */
    public static appointmentProposalsUpdate(data: AppointmentProposalsUpdateData): CancelablePromise<AppointmentProposalsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/appointment_proposals/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointment proposals.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAppointmentProposal
     * @throws ApiError
     */
    public static appointmentProposalsPartialUpdate(data: AppointmentProposalsPartialUpdateData): CancelablePromise<AppointmentProposalsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/appointment_proposals/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointment proposals.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAppointmentProposal
     * @throws ApiError
     */
    public static appointmentProposalsDestroy(data: AppointmentProposalsDestroyData): CancelablePromise<AppointmentProposalsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/appointment_proposals/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class AppointmentSettingsService {
    /**
     * Get Appointment Settings
     * Retrieve the appointment settings for the organization of the requesting user.
     * @returns AppointmentSettings
     * @throws ApiError
     */
    public static appointmentSettingsRetrieve(): CancelablePromise<AppointmentSettingsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/appointment_settings/',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
}

export class AppointmentsService {
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTAppointmentList
     * @throws ApiError
     */
    public static appointmentsList(data: AppointmentsListData = {}): CancelablePromise<AppointmentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/appointments/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * Create a new appointment with auto-populated fields.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsCreate(data: AppointmentsCreateData = {}): CancelablePromise<AppointmentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/appointments/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsRetrieve(data: AppointmentsRetrieveData): CancelablePromise<AppointmentsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/appointments/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsUpdate(data: AppointmentsUpdateData): CancelablePromise<AppointmentsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/appointments/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsPartialUpdate(data: AppointmentsPartialUpdateData): CancelablePromise<AppointmentsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/appointments/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsDestroy(data: AppointmentsDestroyData): CancelablePromise<AppointmentsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/appointments/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsCancelCreate(data: AppointmentsCancelCreateData): CancelablePromise<AppointmentsCancelCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/appointments/{uuid}/cancel/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Confirm an appointment.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsConfirmCreate(data: AppointmentsConfirmCreateData): CancelablePromise<AppointmentsConfirmCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/appointments/{uuid}/confirm/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing appointments.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TAppointment
     * @throws ApiError
     */
    public static appointmentsCreateCaseAppointmentCreate(data: AppointmentsCreateCaseAppointmentCreateData = {}): CancelablePromise<AppointmentsCreateCaseAppointmentCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/appointments/create_case_appointment/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class CalendarsService {
    /**
     * An API endpoint for viewing and editing calendars related to appointments.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTCalendarList
     * @throws ApiError
     */
    public static calendarsList(data: CalendarsListData = {}): CancelablePromise<CalendarsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/calendars/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing calendars related to appointments.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TCalendar
     * @throws ApiError
     */
    public static calendarsCreate(data: CalendarsCreateData = {}): CancelablePromise<CalendarsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/calendars/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing calendars related to appointments.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCalendar
     * @throws ApiError
     */
    public static calendarsRetrieve(data: CalendarsRetrieveData): CancelablePromise<CalendarsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/calendars/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing calendars related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCalendar
     * @throws ApiError
     */
    public static calendarsUpdate(data: CalendarsUpdateData): CancelablePromise<CalendarsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/calendars/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing calendars related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCalendar
     * @throws ApiError
     */
    public static calendarsPartialUpdate(data: CalendarsPartialUpdateData): CancelablePromise<CalendarsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/calendars/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing calendars related to appointments.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TCalendar
     * @throws ApiError
     */
    public static calendarsDestroy(data: CalendarsDestroyData): CancelablePromise<CalendarsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/calendars/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class CallsService {
    /**
     * An API endpoint for viewing and editing calls.
     * @param data The data for the request.
     * @param data.aiRatings ai_ratings
     * @param data.durationRanges duration_ranges
     * @param data.excludeWithoutMessage
     * @param data.forwardedOnly
     * @param data.hasResult
     * @param data.humanRatings human_ratings
     * @param data.isDeleted
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.resultDataLawField
     * @param data.resultClassification result_classification
     * @param data.retellCallId retell_call_id
     * @param data.search A search term.
     * @param data.twilioCallSid twilio_call_sid
     * @returns PaginatedTCallList
     * @throws ApiError
     */
    public static callsList(data: CallsListData = {}): CancelablePromise<CallsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/calls/',
            query: {
                ai_ratings: data.aiRatings,
                duration_ranges: data.durationRanges,
                exclude_without_message: data.excludeWithoutMessage,
                forwarded_only: data.forwardedOnly,
                has_result: data.hasResult,
                human_ratings: data.humanRatings,
                is_deleted: data.isDeleted,
                limit: data.limit,
                offset: data.offset,
                result__data__law__field: data.resultDataLawField,
                result_classification: data.resultClassification,
                retell_call_id: data.retellCallId,
                search: data.search,
                twilio_call_sid: data.twilioCallSid
            }
        });
    }
    
    /**
     * Deny CUSTOMER and CUSTOMER_ADMIN from creating new Call instances.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TCall
     * @throws ApiError
     */
    public static callsCreate(data: CallsCreateData = {}): CancelablePromise<CallsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/calls/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing calls.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCall
     * @throws ApiError
     */
    public static callsRetrieve(data: CallsRetrieveData): CancelablePromise<CallsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/calls/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing calls.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCall
     * @throws ApiError
     */
    public static callsUpdate(data: CallsUpdateData): CancelablePromise<CallsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/calls/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing calls.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCall
     * @throws ApiError
     */
    public static callsPartialUpdate(data: CallsPartialUpdateData): CancelablePromise<CallsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/calls/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing calls.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TCall
     * @throws ApiError
     */
    public static callsDestroy(data: CallsDestroyData): CancelablePromise<CallsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/calls/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing calls.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCall
     * @throws ApiError
     */
    public static callsCreateCaseCreate(data: CallsCreateCaseCreateData): CancelablePromise<CallsCreateCaseCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/calls/{uuid}/create_case/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Store Gemini shadow mode comparison results for a call.
     *
     * This endpoint is called by the voice service to persist Gemini vs GPT
     * extraction comparison data for analysis.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns GeminiShadowComparison
     * @throws ApiError
     */
    public static callsGeminiShadowComparisonCreate(data: CallsGeminiShadowComparisonCreateData): CancelablePromise<CallsGeminiShadowComparisonCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/calls/{uuid}/gemini-shadow-comparison/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTLawyerFeedbackList
     * @throws ApiError
     */
    public static callsLawyerFeedbackList(data: CallsLawyerFeedbackListData = {}): CancelablePromise<CallsLawyerFeedbackListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/calls/lawyer_feedback/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TLawyerFeedback
     * @throws ApiError
     */
    public static callsLawyerFeedbackCreate(data: CallsLawyerFeedbackCreateData = {}): CancelablePromise<CallsLawyerFeedbackCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/calls/lawyer_feedback/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TLawyerFeedback
     * @throws ApiError
     */
    public static callsLawyerFeedbackRetrieve(data: CallsLawyerFeedbackRetrieveData): CancelablePromise<CallsLawyerFeedbackRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/calls/lawyer_feedback/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TLawyerFeedback
     * @throws ApiError
     */
    public static callsLawyerFeedbackUpdate(data: CallsLawyerFeedbackUpdateData): CancelablePromise<CallsLawyerFeedbackUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/calls/lawyer_feedback/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TLawyerFeedback
     * @throws ApiError
     */
    public static callsLawyerFeedbackPartialUpdate(data: CallsLawyerFeedbackPartialUpdateData): CancelablePromise<CallsLawyerFeedbackPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/calls/lawyer_feedback/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @returns TLawyerFeedback
     * @throws ApiError
     */
    public static callsLawyerFeedbackDestroy(data: CallsLawyerFeedbackDestroyData): CancelablePromise<CallsLawyerFeedbackDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/calls/lawyer_feedback/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class CaseCreationIntegrationService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ExternalIntegrationFileDownloadResponse
     * @returns ExternalIntegrationCaseCreationResponse
     * @throws ApiError
     */
    public static caseCreationIntegrationCreate(data: CaseCreationIntegrationCreateData): CancelablePromise<CaseCreationIntegrationCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/case_creation_integration/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class CaseCreatorTempDocumentsService {
    /**
     * API endpoint for managing temporary documents during case creation.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTCaseCreatorTempDocumentList
     * @throws ApiError
     */
    public static caseCreatorTempDocumentsList(data: CaseCreatorTempDocumentsListData = {}): CancelablePromise<CaseCreatorTempDocumentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_creator_temp_documents/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * API endpoint for managing temporary documents during case creation.
     * @param data The data for the request.
     * @param data.formData
     * @returns TCaseCreatorTempDocument
     * @throws ApiError
     */
    public static caseCreatorTempDocumentsCreate(data: CaseCreatorTempDocumentsCreateData = {}): CancelablePromise<CaseCreatorTempDocumentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/case_creator_temp_documents/',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * API endpoint for managing temporary documents during case creation.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCaseCreatorTempDocument
     * @throws ApiError
     */
    public static caseCreatorTempDocumentsRetrieve(data: CaseCreatorTempDocumentsRetrieveData): CancelablePromise<CaseCreatorTempDocumentsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_creator_temp_documents/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * API endpoint for managing temporary documents during case creation.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TCaseCreatorTempDocument
     * @throws ApiError
     */
    public static caseCreatorTempDocumentsUpdate(data: CaseCreatorTempDocumentsUpdateData): CancelablePromise<CaseCreatorTempDocumentsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/case_creator_temp_documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * API endpoint for managing temporary documents during case creation.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TCaseCreatorTempDocument
     * @throws ApiError
     */
    public static caseCreatorTempDocumentsPartialUpdate(data: CaseCreatorTempDocumentsPartialUpdateData): CancelablePromise<CaseCreatorTempDocumentsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/case_creator_temp_documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Delete the specified CaseCreatorTempDocument instance.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TCaseCreatorTempDocument
     * @throws ApiError
     */
    public static caseCreatorTempDocumentsDestroy(data: CaseCreatorTempDocumentsDestroyData): CancelablePromise<CaseCreatorTempDocumentsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/case_creator_temp_documents/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class CaseLifecycleStateReasoningService {
    /**
     * An API endpoint for viewing case lifecycle state reasoning.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTCaseLifecycleStateReasoningList
     * @throws ApiError
     */
    public static caseLifecycleStateReasoningList(data: CaseLifecycleStateReasoningListData = {}): CancelablePromise<CaseLifecycleStateReasoningListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_state_reasoning/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing case lifecycle state reasoning.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCaseLifecycleStateReasoning
     * @throws ApiError
     */
    public static caseLifecycleStateReasoningRetrieve(data: CaseLifecycleStateReasoningRetrieveData): CancelablePromise<CaseLifecycleStateReasoningRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_state_reasoning/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class CaseLifecycleStatesService {
    /**
     * An API endpoint for viewing and editing case lifecycle states.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTCaseLifecycleStateList
     * @throws ApiError
     */
    public static caseLifecycleStatesList(data: CaseLifecycleStatesListData = {}): CancelablePromise<CaseLifecycleStatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_states/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle states.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TCaseLifecycleState
     * @throws ApiError
     */
    public static caseLifecycleStatesCreate(data: CaseLifecycleStatesCreateData = {}): CancelablePromise<CaseLifecycleStatesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/case_lifecycle_states/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle states.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCaseLifecycleState
     * @throws ApiError
     */
    public static caseLifecycleStatesRetrieve(data: CaseLifecycleStatesRetrieveData): CancelablePromise<CaseLifecycleStatesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_states/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle states.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCaseLifecycleState
     * @throws ApiError
     */
    public static caseLifecycleStatesUpdate(data: CaseLifecycleStatesUpdateData): CancelablePromise<CaseLifecycleStatesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/case_lifecycle_states/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Update specific fields of the case lifecycle state.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCaseLifecycleState
     * @throws ApiError
     */
    public static caseLifecycleStatesPartialUpdate(data: CaseLifecycleStatesPartialUpdateData): CancelablePromise<CaseLifecycleStatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/case_lifecycle_states/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle states.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TCaseLifecycleState
     * @throws ApiError
     */
    public static caseLifecycleStatesDestroy(data: CaseLifecycleStatesDestroyData): CancelablePromise<CaseLifecycleStatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/case_lifecycle_states/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Advance the case lifecycle state using the state machine agent.
     *
     * This action fetches the case for the given state UUID, checks feature flags
     * and organisation settings, and triggers the agent to advance the state.
     * Always returns HTTP 200 OK.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCaseLifecycleState
     * @throws ApiError
     */
    public static caseLifecycleStatesAdvanceCreate(data: CaseLifecycleStatesAdvanceCreateData): CancelablePromise<CaseLifecycleStatesAdvanceCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/case_lifecycle_states/{uuid}/advance/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Rate a case lifecycle state by UUID
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static caseLifecycleStatesRateCreate(data: CaseLifecycleStatesRateCreateData): CancelablePromise<CaseLifecycleStatesRateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/case_lifecycle_states/{uuid}/rate/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                404: ''
            }
        });
    }
    
}

export class CaseLifecycleWorkflowsService {
    /**
     * An API endpoint for viewing and editing case lifecycle workflows.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTCaseLifecycleWorkflowList
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsList(data: CaseLifecycleWorkflowsListData = {}): CancelablePromise<CaseLifecycleWorkflowsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_workflows/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle workflows.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TCaseLifecycleWorkflow
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsCreate(data: CaseLifecycleWorkflowsCreateData = {}): CancelablePromise<CaseLifecycleWorkflowsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/case_lifecycle_workflows/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle workflows.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCaseLifecycleWorkflow
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsRetrieve(data: CaseLifecycleWorkflowsRetrieveData): CancelablePromise<CaseLifecycleWorkflowsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_workflows/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle workflows.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCaseLifecycleWorkflow
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsUpdate(data: CaseLifecycleWorkflowsUpdateData): CancelablePromise<CaseLifecycleWorkflowsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/case_lifecycle_workflows/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle workflows.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCaseLifecycleWorkflow
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsPartialUpdate(data: CaseLifecycleWorkflowsPartialUpdateData): CancelablePromise<CaseLifecycleWorkflowsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/case_lifecycle_workflows/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing case lifecycle workflows.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TCaseLifecycleWorkflow
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsDestroy(data: CaseLifecycleWorkflowsDestroyData): CancelablePromise<CaseLifecycleWorkflowsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/case_lifecycle_workflows/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get available auto commit actions
     * Returns all available auto commit settings from loaded actions that can be configured.
     * @returns unknown No response body
     * @throws ApiError
     */
    public static caseLifecycleWorkflowsAvailableActionsRetrieve(): CancelablePromise<CaseLifecycleWorkflowsAvailableActionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/case_lifecycle_workflows/available-actions/'
        });
    }
    
}

export class CasesService {
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.clerk
     * @param data.endDate
     * @param data.hasUnseenActivity
     * @param data.legalField
     * @param data.legalTopic
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search
     * @param data.startDate
     * @param data.state
     * @returns PaginatedTCaseList
     * @throws ApiError
     */
    public static casesList(data: CasesListData = {}): CancelablePromise<CasesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/',
            query: {
                clerk: data.clerk,
                end_date: data.endDate,
                has_unseen_activity: data.hasUnseenActivity,
                legal_field: data.legalField,
                legal_topic: data.legalTopic,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                start_date: data.startDate,
                state: data.state
            }
        });
    }
    
    /**
     * Create a case instance.
     *
     * This endpoint uses a dedicated CaseCreateSerializer for input validation and data
     * structuring, which is separate from the regular case serializers. This allows us to
     * have a specialized schema for case creation that includes nested client, opponent,
     * and law data, as well as document references and AI augmented fields.
     *
     * The response will use the appropriate role-based serializer (ClientCaseSerializer,
     * CustomerCaseSerializer, etc.) based on the authenticated user's role.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TCase
     * @throws ApiError
     */
    public static casesCreate(data: CasesCreateData): CancelablePromise<CasesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TCase
     * @throws ApiError
     */
    public static casesRetrieve(data: CasesRetrieveData): CancelablePromise<CasesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCase
     * @throws ApiError
     */
    public static casesUpdate(data: CasesUpdateData): CancelablePromise<CasesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/cases/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TCase
     * @throws ApiError
     */
    public static casesPartialUpdate(data: CasesPartialUpdateData): CancelablePromise<CasesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/cases/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TCase
     * @throws ApiError
     */
    public static casesDestroy(data: CasesDestroyData): CancelablePromise<CasesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/cases/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Generate an AI summary of the case inquiry. No request body is required as the case is identified by UUID in the URL path.
     * @param data The data for the request.
     * @param data.uuid
     * @returns string Streaming response that delivers chunks of the AI-generated summary incrementally in `text/plain` format. Clients should consume the response progressively.
     * @throws ApiError
     */
    public static casesAiSummaryCreate(data: CasesAiSummaryCreateData): CancelablePromise<CasesAiSummaryCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/ai-summary/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * List case appointment proposals
     * Get all appointment proposals for a specific case
     * @param data The data for the request.
     * @param data.uuid
     * @returns unknown
     * @throws ApiError
     */
    public static casesAppointmentProposalsRetrieve(data: CasesAppointmentProposalsRetrieveData): CancelablePromise<CasesAppointmentProposalsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/{uuid}/appointment-proposals/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * List case appointments
     * Get all appointments for a specific case
     * @param data The data for the request.
     * @param data.uuid
     * @param data.clerk
     * @param data.endDate
     * @param data.hasUnseenActivity
     * @param data.legalField
     * @param data.legalTopic
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search
     * @param data.startDate
     * @param data.state
     * @returns PaginatedCaseAppointmentsList
     * @throws ApiError
     */
    public static casesAppointmentsList(data: CasesAppointmentsListData): CancelablePromise<CasesAppointmentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/{uuid}/appointments/',
            path: {
                uuid: data.uuid
            },
            query: {
                clerk: data.clerk,
                end_date: data.endDate,
                has_unseen_activity: data.hasUnseenActivity,
                legal_field: data.legalField,
                legal_topic: data.legalTopic,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                start_date: data.startDate,
                state: data.state
            }
        });
    }
    
    /**
     * Assign or remove a workflow from a case
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TAssignWorkflowResponse
     * @throws ApiError
     */
    public static casesAssignWorkflowPartialUpdate(data: CasesAssignWorkflowPartialUpdateData): CancelablePromise<CasesAssignWorkflowPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/cases/{uuid}/assign-workflow/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns CreateWordDocumentResponse
     * @throws ApiError
     */
    public static casesCreateWordDocumentCreate(data: CasesCreateWordDocumentCreateData): CancelablePromise<CasesCreateWordDocumentCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/create_word_document/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns CreateWordDocumentFromPlaceholderValuesResponse
     * @throws ApiError
     */
    public static casesCreateWordDocumentFromPlaceholderValuesCreate(data: CasesCreateWordDocumentFromPlaceholderValuesCreateData): CancelablePromise<CasesCreateWordDocumentFromPlaceholderValuesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/create_word_document_from_placeholder_values/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns binary
     * @throws ApiError
     */
    public static casesCreateWordDocumentPreviewBlobCreate(data: CasesCreateWordDocumentPreviewBlobCreateData): CancelablePromise<CasesCreateWordDocumentPreviewBlobCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/create_word_document_preview_blob/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * List case documents
     * Get all documents for a specific case
     * @param data The data for the request.
     * @param data.uuid
     * @param data.clerk
     * @param data.endDate
     * @param data.hasUnseenActivity
     * @param data.legalField
     * @param data.legalTopic
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search
     * @param data.startDate
     * @param data.state
     * @returns PaginatedDocumentList
     * @throws ApiError
     */
    public static casesDocumentsList(data: CasesDocumentsListData): CancelablePromise<CasesDocumentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/{uuid}/documents/',
            path: {
                uuid: data.uuid
            },
            query: {
                clerk: data.clerk,
                end_date: data.endDate,
                has_unseen_activity: data.hasUnseenActivity,
                legal_field: data.legalField,
                legal_topic: data.legalTopic,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                start_date: data.startDate,
                state: data.state
            }
        });
    }
    
    /**
     * Download all documents associated with a case as a ZIP archive.
     * @param data The data for the request.
     * @param data.uuid
     * @returns unknown
     * @throws ApiError
     */
    public static casesDownloadDocumentsZipRetrieve(data: CasesDownloadDocumentsZipRetrieveData): CancelablePromise<CasesDownloadDocumentsZipRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/{uuid}/download-documents-zip/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns FindWordDocumentTemplatePlaceholderValuesResponse
     * @throws ApiError
     */
    public static casesFindWordDocumentTemplatePlaceholderValuesCreate(data: CasesFindWordDocumentTemplatePlaceholderValuesCreateData): CancelablePromise<CasesFindWordDocumentTemplatePlaceholderValuesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/find_word_document_template_placeholder_values/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing cases.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns string Streaming response that delivers chunks of the document incrementally in `text/plain` format. Clients should consume the response progressively.
     * @throws ApiError
     */
    public static casesGenerateDocumentHtmlStreamCreate(data: CasesGenerateDocumentHtmlStreamCreateData): CancelablePromise<CasesGenerateDocumentHtmlStreamCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/generate_document_html_stream/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Send an email related to the case.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns SendCaseEmailResponse
     * @throws ApiError
     */
    public static casesSendEmailCreate(data: CasesSendEmailCreateData): CancelablePromise<CasesSendEmailCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/cases/{uuid}/send_email/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve a case by its access token.
     * This endpoint allows retrieving a case using the access token as a query parameter.
     * @param data The data for the request.
     * @param data.accessToken Case access token
     * @returns TCase
     * @throws ApiError
     */
    public static casesByAccessTokenRetrieve(data: CasesByAccessTokenRetrieveData = {}): CancelablePromise<CasesByAccessTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/by-access-token/',
            query: {
                access_token: data.accessToken
            }
        });
    }
    
    /**
     * Return the generic mappeable fields for the case model.
     * @param data The data for the request.
     * @param data.clerk
     * @param data.endDate
     * @param data.hasUnseenActivity
     * @param data.legalField
     * @param data.legalTopic
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search
     * @param data.startDate
     * @param data.state
     * @returns PaginatedTGenericDataMapperList
     * @throws ApiError
     */
    public static casesGenericDatamappersList(data: CasesGenericDatamappersListData = {}): CancelablePromise<CasesGenericDatamappersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/generic_datamappers/',
            query: {
                clerk: data.clerk,
                end_date: data.endDate,
                has_unseen_activity: data.hasUnseenActivity,
                legal_field: data.legalField,
                legal_topic: data.legalTopic,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                start_date: data.startDate,
                state: data.state
            }
        });
    }
    
    /**
     * Get case state counts
     * Get counts for all case states in a single optimized request. Returns total counts per state and optionally filtered counts if additional filters (clerk, legal_field, search, has_unseen_activity) are provided.
     * @param data The data for the request.
     * @param data.clerk Filter by clerk UUID
     * @param data.hasUnseenActivity Filter by unseen activity status
     * @param data.legalField Filter by legal field
     * @param data.search Search in client name, note, legal field, legal topic, clerk name
     * @returns CaseStateCounts
     * @throws ApiError
     */
    public static casesStateCountsRetrieve(data: CasesStateCountsRetrieveData = {}): CancelablePromise<CasesStateCountsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/cases/state-counts/',
            query: {
                clerk: data.clerk,
                has_unseen_activity: data.hasUnseenActivity,
                legal_field: data.legalField,
                search: data.search
            }
        });
    }
    
}

export class ChatPreferencesService {
    /**
     * An API endpoint for viewing and editing Chat Preferences.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedTChatPreferenceList
     * @throws ApiError
     */
    public static chatPreferencesList(data: ChatPreferencesListData = {}): CancelablePromise<ChatPreferencesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/chat_preferences/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Chat Preferences.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesCreate(data: ChatPreferencesCreateData = {}): CancelablePromise<ChatPreferencesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/chat_preferences/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Chat Preferences.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesRetrieve(data: ChatPreferencesRetrieveData): CancelablePromise<ChatPreferencesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/chat_preferences/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Chat Preferences.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesUpdate(data: ChatPreferencesUpdateData): CancelablePromise<ChatPreferencesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/chat_preferences/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Chat Preferences.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesPartialUpdate(data: ChatPreferencesPartialUpdateData): CancelablePromise<ChatPreferencesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/chat_preferences/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Chat Preferences.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesDestroy(data: ChatPreferencesDestroyData): CancelablePromise<ChatPreferencesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/chat_preferences/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Dismiss a preference suggestion.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesDismissSuggestionCreate(data: ChatPreferencesDismissSuggestionCreateData = {}): CancelablePromise<ChatPreferencesDismissSuggestionCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/chat_preferences/dismiss-suggestion/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Generate a title for a chat preference based on its content.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesGenerateTitleCreate(data: ChatPreferencesGenerateTitleCreateData = {}): CancelablePromise<ChatPreferencesGenerateTitleCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/chat_preferences/generate-title/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Save a preference suggestion as an actual preference.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TChatPreference
     * @throws ApiError
     */
    public static chatPreferencesSaveSuggestionCreate(data: ChatPreferencesSaveSuggestionCreateData = {}): CancelablePromise<ChatPreferencesSaveSuggestionCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/chat_preferences/save-suggestion/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class DeliveryEventsService {
    /**
     * @param data The data for the request.
     * @param data.email Filter delivery events by email UUID
     * @param data.event Filter delivery events by event type
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTDeliveryEventList
     * @throws ApiError
     */
    public static deliveryEventsList(data: DeliveryEventsListData = {}): CancelablePromise<DeliveryEventsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/delivery_events/',
            query: {
                email: data.email,
                event: data.event,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.email Filter delivery events by email UUID
     * @param data.event Filter delivery events by event type
     * @param data.requestBody
     * @returns TDeliveryEvent
     * @throws ApiError
     */
    public static deliveryEventsCreate(data: DeliveryEventsCreateData = {}): CancelablePromise<DeliveryEventsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/delivery_events/',
            query: {
                email: data.email,
                event: data.event
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @param data.email Filter delivery events by email UUID
     * @param data.event Filter delivery events by event type
     * @returns TDeliveryEvent
     * @throws ApiError
     */
    public static deliveryEventsRetrieve(data: DeliveryEventsRetrieveData): CancelablePromise<DeliveryEventsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/delivery_events/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                email: data.email,
                event: data.event
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.email Filter delivery events by email UUID
     * @param data.event Filter delivery events by event type
     * @param data.requestBody
     * @returns TDeliveryEvent
     * @throws ApiError
     */
    public static deliveryEventsUpdate(data: DeliveryEventsUpdateData): CancelablePromise<DeliveryEventsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/delivery_events/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                email: data.email,
                event: data.event
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.email Filter delivery events by email UUID
     * @param data.event Filter delivery events by event type
     * @param data.requestBody
     * @returns TDeliveryEvent
     * @throws ApiError
     */
    public static deliveryEventsPartialUpdate(data: DeliveryEventsPartialUpdateData): CancelablePromise<DeliveryEventsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/delivery_events/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                email: data.email,
                event: data.event
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.email Filter delivery events by email UUID
     * @param data.event Filter delivery events by event type
     * @returns TDeliveryEvent
     * @throws ApiError
     */
    public static deliveryEventsDestroy(data: DeliveryEventsDestroyData): CancelablePromise<DeliveryEventsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/delivery_events/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                email: data.email,
                event: data.event
            }
        });
    }
    
}

export class DocumentPlaceholdersService {
    /**
     * API endpoint for managing document placeholders.
     * Only accessible by superusers.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedDocumentPlaceholderList
     * @throws ApiError
     */
    public static documentPlaceholdersList(data: DocumentPlaceholdersListData = {}): CancelablePromise<DocumentPlaceholdersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/document_placeholders/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * Disable creation of placeholders.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns DocumentPlaceholder
     * @throws ApiError
     */
    public static documentPlaceholdersCreate(data: DocumentPlaceholdersCreateData): CancelablePromise<DocumentPlaceholdersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/document_placeholders/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for managing document placeholders.
     * Only accessible by superusers.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns DocumentPlaceholder
     * @throws ApiError
     */
    public static documentPlaceholdersRetrieve(data: DocumentPlaceholdersRetrieveData): CancelablePromise<DocumentPlaceholdersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/document_placeholders/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * API endpoint for managing document placeholders.
     * Only accessible by superusers.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns DocumentPlaceholderUpdate
     * @throws ApiError
     */
    public static documentPlaceholdersUpdate(data: DocumentPlaceholdersUpdateData): CancelablePromise<DocumentPlaceholdersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/document_placeholders/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for managing document placeholders.
     * Only accessible by superusers.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns DocumentPlaceholderUpdate
     * @throws ApiError
     */
    public static documentPlaceholdersPartialUpdate(data: DocumentPlaceholdersPartialUpdateData): CancelablePromise<DocumentPlaceholdersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/document_placeholders/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for managing document placeholders.
     * Only accessible by superusers.
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static documentPlaceholdersDestroy(data: DocumentPlaceholdersDestroyData): CancelablePromise<DocumentPlaceholdersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/document_placeholders/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Generate label suggestions for a placeholder name using AI.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns DocumentPlaceholderLabelsResponse
     * @throws ApiError
     */
    public static documentPlaceholdersGenerateLabelsCreate(data: DocumentPlaceholdersGenerateLabelsCreateData): CancelablePromise<DocumentPlaceholdersGenerateLabelsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/document_placeholders/generate_labels/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class DocumentTemplatesService {
    /**
     * An API endpoint for viewing and editing DocumentTemplates.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTDocumentTemplateList
     * @throws ApiError
     */
    public static documentTemplatesList(data: DocumentTemplatesListData = {}): CancelablePromise<DocumentTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/document_templates/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing DocumentTemplates.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TDocumentTemplate
     * @throws ApiError
     */
    public static documentTemplatesCreate(data: DocumentTemplatesCreateData = {}): CancelablePromise<DocumentTemplatesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/document_templates/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing DocumentTemplates.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TDocumentTemplate
     * @throws ApiError
     */
    public static documentTemplatesRetrieve(data: DocumentTemplatesRetrieveData): CancelablePromise<DocumentTemplatesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing DocumentTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TDocumentTemplate
     * @throws ApiError
     */
    public static documentTemplatesUpdate(data: DocumentTemplatesUpdateData): CancelablePromise<DocumentTemplatesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing DocumentTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TDocumentTemplate
     * @throws ApiError
     */
    public static documentTemplatesPartialUpdate(data: DocumentTemplatesPartialUpdateData): CancelablePromise<DocumentTemplatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing DocumentTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TDocumentTemplate
     * @throws ApiError
     */
    public static documentTemplatesDestroy(data: DocumentTemplatesDestroyData): CancelablePromise<DocumentTemplatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Copy a specific instance of a document template.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TDocumentTemplate
     * @throws ApiError
     */
    public static documentTemplatesCopyCreate(data: DocumentTemplatesCopyCreateData): CancelablePromise<DocumentTemplatesCopyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/document_templates/{uuid}/copy/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class DocumentsService {
    /**
     * An API endpoint for viewing and editing Documents.
     * @param data The data for the request.
     * @param data.caseUuid
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTDocumentList
     * @throws ApiError
     */
    public static documentsList(data: DocumentsListData = {}): CancelablePromise<DocumentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/documents/',
            query: {
                case__uuid: data.caseUuid,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Documents.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TDocument
     * @throws ApiError
     */
    public static documentsCreate(data: DocumentsCreateData = {}): CancelablePromise<DocumentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Bulk sync documents between platforms
     * Initiates bulk async syncing of documents. Sends JUPUS documents to Actaport and imports Actaport documents into JUPUS. Progress updates are sent via WebSocket.
     * @param data The data for the request.
     * @param data.caseUuid UUID of the case containing the documents
     * @param data.requestBody
     * @returns BulkSyncDocumentsResponse
     * @throws ApiError
     */
    public static documentsBulkSyncPlatformsCreate(data: DocumentsBulkSyncPlatformsCreateData): CancelablePromise<DocumentsBulkSyncPlatformsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{case_uuid}/bulk-sync-platforms/',
            path: {
                case_uuid: data.caseUuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Import document from Actaport
     * Initiates an asynchronous import of a document from Actaport into JUPUS. The document will be downloaded and a JUPUS Document record created.
     * @param data The data for the request.
     * @param data.caseUuid UUID of the case
     * @param data.requestBody
     * @returns ImportDocumentResponse
     * @throws ApiError
     */
    public static documentsImportFromActaportCreate(data: DocumentsImportFromActaportCreateData): CancelablePromise<DocumentsImportFromActaportCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{case_uuid}/import-from-actaport/',
            path: {
                case_uuid: data.caseUuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Refresh Actaport documents
     * Fetch latest documents from Actaport and update virtual documents list
     * @param data The data for the request.
     * @param data.caseUuid UUID of the case
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static documentsRefreshActaportDocumentsCreate(data: DocumentsRefreshActaportDocumentsCreateData): CancelablePromise<DocumentsRefreshActaportDocumentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{case_uuid}/refresh-actaport-documents/',
            path: {
                case_uuid: data.caseUuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Upload a document for processing
     * Upload a single document for the specified case
     * @param data The data for the request.
     * @param data.caseUuid UUID of the case
     * @param data.formData
     * @returns Document
     * @throws ApiError
     */
    public static documentsUploadCreate(data: DocumentsUploadCreateData): CancelablePromise<DocumentsUploadCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{case_uuid}/upload/',
            path: {
                case_uuid: data.caseUuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Documents.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TDocument
     * @throws ApiError
     */
    public static documentsRetrieve(data: DocumentsRetrieveData): CancelablePromise<DocumentsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/documents/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Documents.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TDocument
     * @throws ApiError
     */
    public static documentsUpdate(data: DocumentsUpdateData): CancelablePromise<DocumentsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Documents.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TDocument
     * @throws ApiError
     */
    public static documentsPartialUpdate(data: DocumentsPartialUpdateData): CancelablePromise<DocumentsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Override destroy to handle document-specific deletion logic.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TDocument
     * @throws ApiError
     */
    public static documentsDestroy(data: DocumentsDestroyData): CancelablePromise<DocumentsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/documents/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Documents.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns DocumentEditTokenResponse
     * @throws ApiError
     */
    public static documentsCreateEditTokenCreate(data: DocumentsCreateEditTokenCreateData): CancelablePromise<DocumentsCreateEditTokenCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{uuid}/create-edit-token/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Generate AI-powered document title
     * Generate a better title for a document using AI analysis. Optionally accepts current document organization state to analyze only specific pages.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns GenerateTitleResponse
     * @throws ApiError
     */
    public static documentsGenerateTitleCreate(data: DocumentsGenerateTitleCreateData): CancelablePromise<DocumentsGenerateTitleCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{uuid}/generate-title/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Retry processing a document that failed during metadata enrichment.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TDocument
     * @throws ApiError
     */
    public static documentsRetryProcessingCreate(data: DocumentsRetryProcessingCreateData): CancelablePromise<DocumentsRetryProcessingCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{uuid}/retry-processing/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Revert document to original
     * Revert a document back to its original PDF version, removing any modifications
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns Document
     * @throws ApiError
     */
    public static documentsRevertToOriginalCreate(data: DocumentsRevertToOriginalCreateData): CancelablePromise<DocumentsRevertToOriginalCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{uuid}/revert-to-original/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Send document to Actaport
     * Initiates an asynchronous process to send a document to Actaport. Returns immediately with sync status.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SendToActaportResponse
     * @returns SendToActaportResponse
     * @throws ApiError
     */
    public static documentsSendToActaportCreate(data: DocumentsSendToActaportCreateData): CancelablePromise<DocumentsSendToActaportCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{uuid}/send-to-actaport/',
            path: {
                uuid: data.uuid
            },
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Get document thumbnails
     * Retrieve thumbnail images for a specific document
     * @param data The data for the request.
     * @param data.uuid
     * @returns DocumentThumbnails
     * @throws ApiError
     */
    public static documentsThumbnailsRetrieve(data: DocumentsThumbnailsRetrieveData): CancelablePromise<DocumentsThumbnailsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/documents/{uuid}/thumbnails/',
            path: {
                uuid: data.uuid
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * Upload modified PDF
     * Upload a modified PDF file to replace the current document version
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns Document
     * @throws ApiError
     */
    public static documentsUploadModifiedCreate(data: DocumentsUploadModifiedCreateData): CancelablePromise<DocumentsUploadModifiedCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/{uuid}/upload-modified/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Upload a document for chat session group
     * Upload a document for a specific chat session group in global AI chat
     * @param data The data for the request.
     * @param data.groupUuid UUID of the chat session group
     * @param data.formData
     * @returns Document
     * @throws ApiError
     */
    public static documentsChatSessionGroupUploadCreate(data: DocumentsChatSessionGroupUploadCreateData): CancelablePromise<DocumentsChatSessionGroupUploadCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/chat-session-group/{group_uuid}/upload/',
            path: {
                group_uuid: data.groupUuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: '',
                404: ''
            }
        });
    }
    
    /**
     * Upload a document for chat session
     * Upload a document for a specific chat session in global AI chat
     * @param data The data for the request.
     * @param data.sessionUuid UUID of the chat session
     * @param data.formData
     * @returns Document
     * @throws ApiError
     */
    public static documentsChatSessionUploadCreate(data: DocumentsChatSessionUploadCreateData): CancelablePromise<DocumentsChatSessionUploadCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/chat-session/{session_uuid}/upload/',
            path: {
                session_uuid: data.sessionUuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: '',
                404: ''
            }
        });
    }
    
    /**
     * Reorganize documents
     * Reorganize documents by performing merge/split operations. This endpoint handles creating new documents from reorganized PDFs and deleting the old ones.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns DocumentReorganizationResponse
     * @throws ApiError
     */
    public static documentsReorganizeCreate(data: DocumentsReorganizeCreateData): CancelablePromise<DocumentsReorganizeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/reorganize/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                404: ''
            }
        });
    }
    
    /**
     * Split document with AI
     * Use AI to intelligently split a document based on content analysis
     * @param data The data for the request.
     * @param data.requestBody
     * @returns DocumentSplitWithAIResponse
     * @throws ApiError
     */
    public static documentsSplitWithAiCreate(data: DocumentsSplitWithAiCreateData): CancelablePromise<DocumentsSplitWithAiCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/documents/split-with-ai/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
}

export class DuplicateCaseMatchesService {
    /**
     * ViewSet for managing duplicate case matches.
     *
     * Provides endpoints to:
     * - List pending duplicate matches for a source case
     * - Update match status (confirm/dismiss)
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedDuplicateCaseMatchList
     * @throws ApiError
     */
    public static duplicateCaseMatchesList(data: DuplicateCaseMatchesListData = {}): CancelablePromise<DuplicateCaseMatchesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/duplicate_case_matches/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * ViewSet for managing duplicate case matches.
     *
     * Provides endpoints to:
     * - List pending duplicate matches for a source case
     * - Update match status (confirm/dismiss)
     * @param data The data for the request.
     * @param data.requestBody
     * @returns DuplicateCaseMatch
     * @throws ApiError
     */
    public static duplicateCaseMatchesCreate(data: DuplicateCaseMatchesCreateData = {}): CancelablePromise<DuplicateCaseMatchesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/duplicate_case_matches/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing duplicate case matches.
     *
     * Provides endpoints to:
     * - List pending duplicate matches for a source case
     * - Update match status (confirm/dismiss)
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns DuplicateCaseMatch
     * @throws ApiError
     */
    public static duplicateCaseMatchesRetrieve(data: DuplicateCaseMatchesRetrieveData): CancelablePromise<DuplicateCaseMatchesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/duplicate_case_matches/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * ViewSet for managing duplicate case matches.
     *
     * Provides endpoints to:
     * - List pending duplicate matches for a source case
     * - Update match status (confirm/dismiss)
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns DuplicateCaseMatch
     * @throws ApiError
     */
    public static duplicateCaseMatchesUpdate(data: DuplicateCaseMatchesUpdateData): CancelablePromise<DuplicateCaseMatchesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/duplicate_case_matches/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing duplicate case matches.
     *
     * Provides endpoints to:
     * - List pending duplicate matches for a source case
     * - Update match status (confirm/dismiss)
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns DuplicateCaseMatch
     * @throws ApiError
     */
    public static duplicateCaseMatchesPartialUpdate(data: DuplicateCaseMatchesPartialUpdateData): CancelablePromise<DuplicateCaseMatchesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/duplicate_case_matches/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing duplicate case matches.
     *
     * Provides endpoints to:
     * - List pending duplicate matches for a source case
     * - Update match status (confirm/dismiss)
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static duplicateCaseMatchesDestroy(data: DuplicateCaseMatchesDestroyData): CancelablePromise<DuplicateCaseMatchesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/duplicate_case_matches/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get all pending duplicate matches for a specific source case
     * @param data The data for the request.
     * @param data.caseUuid
     * @returns DuplicateCaseMatch
     * @throws ApiError
     */
    public static duplicateCaseMatchesForCaseList(data: DuplicateCaseMatchesForCaseListData): CancelablePromise<DuplicateCaseMatchesForCaseListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/duplicate_case_matches/for_case/{case_uuid}/',
            path: {
                case_uuid: data.caseUuid
            }
        });
    }
    
}

export class EditorService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns EditorUploadResponse
     * @throws ApiError
     */
    public static editorUploadCreate(data: EditorUploadCreateData): CancelablePromise<EditorUploadCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/editor/upload',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'No response body',
                403: 'No response body'
            }
        });
    }
    
}

export class EmailTemplatesService {
    /**
     * @param data The data for the request.
     * @param data.lawField
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @param data.type
     * @returns PaginatedTEmailTemplateList
     * @throws ApiError
     */
    public static emailTemplatesList(data: EmailTemplatesListData = {}): CancelablePromise<EmailTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/email_templates/',
            query: {
                law_field: data.lawField,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                type: data.type
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TEmailTemplate
     * @throws ApiError
     */
    public static emailTemplatesCreate(data: EmailTemplatesCreateData = {}): CancelablePromise<EmailTemplatesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/email_templates/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TEmailTemplate
     * @throws ApiError
     */
    public static emailTemplatesRetrieve(data: EmailTemplatesRetrieveData): CancelablePromise<EmailTemplatesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/email_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TEmailTemplate
     * @throws ApiError
     */
    public static emailTemplatesUpdate(data: EmailTemplatesUpdateData): CancelablePromise<EmailTemplatesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/email_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TEmailTemplate
     * @throws ApiError
     */
    public static emailTemplatesPartialUpdate(data: EmailTemplatesPartialUpdateData): CancelablePromise<EmailTemplatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/email_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @returns TEmailTemplate
     * @throws ApiError
     */
    public static emailTemplatesDestroy(data: EmailTemplatesDestroyData): CancelablePromise<EmailTemplatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/email_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class EmailsService {
    /**
     * @param data The data for the request.
     * @param data._case Filter emails by case UUID
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTEmailList
     * @throws ApiError
     */
    public static emailsList(data: EmailsListData = {}): CancelablePromise<EmailsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/emails/',
            query: {
                case: data._case,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data._case Filter emails by case UUID
     * @param data.requestBody
     * @returns TEmail
     * @throws ApiError
     */
    public static emailsCreate(data: EmailsCreateData = {}): CancelablePromise<EmailsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/emails/',
            query: {
                case: data._case
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this email.
     * @param data._case Filter emails by case UUID
     * @returns TEmail
     * @throws ApiError
     */
    public static emailsRetrieve(data: EmailsRetrieveData): CancelablePromise<EmailsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/emails/{id}/',
            path: {
                id: data.id
            },
            query: {
                case: data._case
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this email.
     * @param data._case Filter emails by case UUID
     * @param data.requestBody
     * @returns TEmail
     * @throws ApiError
     */
    public static emailsUpdate(data: EmailsUpdateData): CancelablePromise<EmailsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/emails/{id}/',
            path: {
                id: data.id
            },
            query: {
                case: data._case
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this email.
     * @param data._case Filter emails by case UUID
     * @param data.requestBody
     * @returns TEmail
     * @throws ApiError
     */
    public static emailsPartialUpdate(data: EmailsPartialUpdateData): CancelablePromise<EmailsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/emails/{id}/',
            path: {
                id: data.id
            },
            query: {
                case: data._case
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this email.
     * @param data._case Filter emails by case UUID
     * @returns TEmail
     * @throws ApiError
     */
    public static emailsDestroy(data: EmailsDestroyData): CancelablePromise<EmailsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/emails/{id}/',
            path: {
                id: data.id
            },
            query: {
                case: data._case
            }
        });
    }
    
    /**
     * Render an email template.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data._case Filter emails by case UUID
     * @returns EmailRenderTemplateResponse
     * @throws ApiError
     */
    public static emailsRenderTemplateCreate(data: EmailsRenderTemplateCreateData): CancelablePromise<EmailsRenderTemplateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/emails/render_template/',
            query: {
                case: data._case
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class EntitiesService {
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTEntityList
     * @throws ApiError
     */
    public static entitiesList(data: EntitiesListData = {}): CancelablePromise<EntitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/entities/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TEntity
     * @throws ApiError
     */
    public static entitiesCreate(data: EntitiesCreateData = {}): CancelablePromise<EntitiesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/entities/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TEntity
     * @throws ApiError
     */
    public static entitiesRetrieve(data: EntitiesRetrieveData): CancelablePromise<EntitiesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/entities/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TEntity
     * @throws ApiError
     */
    public static entitiesUpdate(data: EntitiesUpdateData): CancelablePromise<EntitiesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/entities/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TEntity
     * @throws ApiError
     */
    public static entitiesPartialUpdate(data: EntitiesPartialUpdateData): CancelablePromise<EntitiesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/entities/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TEntity
     * @throws ApiError
     */
    public static entitiesDestroy(data: EntitiesDestroyData): CancelablePromise<EntitiesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/entities/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TEntityWithRelationship
     * @throws ApiError
     */
    public static entitiesAddCaseDataRelationshipCreate(data: EntitiesAddCaseDataRelationshipCreateData): CancelablePromise<EntitiesAddCaseDataRelationshipCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/entities/{uuid}/add_case_data_relationship/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TEntityRemoveCaseDataRelationshipResponse
     * @throws ApiError
     */
    public static entitiesRemoveCaseDataRelationshipCreate(data: EntitiesRemoveCaseDataRelationshipCreateData): CancelablePromise<EntitiesRemoveCaseDataRelationshipCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/entities/{uuid}/remove_case_data_relationship/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing entities.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TSwitchUniqueCaseDataRelationshipResponse
     * @throws ApiError
     */
    public static entitiesSwitchUniqueCaseDataRelationshipCreate(data: EntitiesSwitchUniqueCaseDataRelationshipCreateData): CancelablePromise<EntitiesSwitchUniqueCaseDataRelationshipCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/entities/switch_unique_case_data_relationship/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class EventService {
    /**
     * /api/v3/events/
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown No response body
     * @throws ApiError
     */
    public static eventCreate(data: EventCreateData): CancelablePromise<EventCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/event/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class EventsService {
    /**
     * An API endpoint for tracking events and metrics.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedGenericMetricEventList
     * @throws ApiError
     */
    public static eventsList(data: EventsListData = {}): CancelablePromise<EventsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/events/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for tracking events and metrics.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns GenericMetricEvent
     * @throws ApiError
     */
    public static eventsCreate(data: EventsCreateData): CancelablePromise<EventsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/events/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for tracking events and metrics.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns GenericMetricEvent
     * @throws ApiError
     */
    public static eventsRetrieve(data: EventsRetrieveData): CancelablePromise<EventsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/events/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for tracking events and metrics.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns GenericMetricEvent
     * @throws ApiError
     */
    public static eventsUpdate(data: EventsUpdateData): CancelablePromise<EventsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/events/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for tracking events and metrics.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns GenericMetricEvent
     * @throws ApiError
     */
    public static eventsPartialUpdate(data: EventsPartialUpdateData): CancelablePromise<EventsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/events/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for tracking events and metrics.
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static eventsDestroy(data: EventsDestroyData): CancelablePromise<EventsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/events/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Track a generic event with custom properties
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static eventsTrackCreate(data: EventsTrackCreateData): CancelablePromise<EventsTrackCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/events/track/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class FeatureFlagsService {
    /**
     * Check Feature Flag
     * Check if a feature flag is enabled for the current user and organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FeatureFlagCheckResponse
     * @throws ApiError
     */
    public static featureFlagsCheckCreate(data: FeatureFlagsCheckCreateData): CancelablePromise<FeatureFlagsCheckCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/feature_flags/check/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
    /**
     * Check Feature Flag by Access Token
     * Check if a feature flag is enabled for the client portal using access token.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FeatureFlagCheckResponse
     * @throws ApiError
     */
    public static featureFlagsCheckByAccessTokenCreate(data: FeatureFlagsCheckByAccessTokenCreateData): CancelablePromise<FeatureFlagsCheckByAccessTokenCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/feature_flags/check_by_access_token/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
}

export class FeedbackService {
    /**
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @returns PaginatedTFeedbackList
     * @throws ApiError
     */
    public static feedbackList(data: FeedbackListData = {}): CancelablePromise<FeedbackListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/feedback/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TFeedback
     * @throws ApiError
     */
    public static feedbackCreate(data: FeedbackCreateData = {}): CancelablePromise<FeedbackCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/feedback/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TFeedback
     * @throws ApiError
     */
    public static feedbackRetrieve(data: FeedbackRetrieveData): CancelablePromise<FeedbackRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/feedback/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TFeedback
     * @throws ApiError
     */
    public static feedbackUpdate(data: FeedbackUpdateData): CancelablePromise<FeedbackUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/feedback/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TFeedback
     * @throws ApiError
     */
    public static feedbackPartialUpdate(data: FeedbackPartialUpdateData): CancelablePromise<FeedbackPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/feedback/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @returns TFeedback
     * @throws ApiError
     */
    public static feedbackDestroy(data: FeedbackDestroyData): CancelablePromise<FeedbackDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/feedback/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class FormsService {
    /**
     * An API endpoint for viewing and editing forms.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @param data.tag * `MASTER` - Master
     * * `PREFILLED` - Prefilled
     * * `SIGNED` - Signed
     * @returns PaginatedTFormList
     * @throws ApiError
     */
    public static formsList(data: FormsListData = {}): CancelablePromise<FormsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/forms/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                tag: data.tag
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing forms.
     * @param data The data for the request.
     * @param data.formData
     * @returns TForm
     * @throws ApiError
     */
    public static formsCreate(data: FormsCreateData = {}): CancelablePromise<FormsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/forms/',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * An API endpoint for viewing and editing forms.
     * @param data The data for the request.
     * @param data.id Record UUID
     * @returns TForm
     * @throws ApiError
     */
    public static formsRetrieve(data: FormsRetrieveData): CancelablePromise<FormsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/forms/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing forms.
     * @param data The data for the request.
     * @param data.id A UUID string identifying this form.
     * @param data.formData
     * @returns TForm
     * @throws ApiError
     */
    public static formsUpdate(data: FormsUpdateData): CancelablePromise<FormsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/forms/{id}/',
            path: {
                id: data.id
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * An API endpoint for viewing and editing forms.
     * @param data The data for the request.
     * @param data.id A UUID string identifying this form.
     * @param data.formData
     * @returns TForm
     * @throws ApiError
     */
    public static formsPartialUpdate(data: FormsPartialUpdateData): CancelablePromise<FormsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/forms/{id}/',
            path: {
                id: data.id
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * An API endpoint for viewing and editing forms.
     * @param data The data for the request.
     * @param data.id A UUID string identifying this form.
     * @returns TForm
     * @throws ApiError
     */
    public static formsDestroy(data: FormsDestroyData): CancelablePromise<FormsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/forms/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Retrieve the document creation token for third-party access.
     * @param data The data for the request.
     * @param data.id A UUID string identifying this form.
     * @returns ThirdPartyDocumentCreationTokenResponse
     * @throws ApiError
     */
    public static formsThirdPartyTokenRetrieve(data: FormsThirdPartyTokenRetrieveData): CancelablePromise<FormsThirdPartyTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/forms/{id}/third-party-token/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Get the PDF form data for a specific request token.
     * Equivalent to v2 /request/form endpoint.
     * @param data The data for the request.
     * @param data.token Request token
     * @returns RequestForm
     * @throws ApiError
     */
    public static formsPdfFormRetrieve(data: FormsPdfFormRetrieveData): CancelablePromise<FormsPdfFormRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/forms/pdf-form/{token}/',
            path: {
                token: data.token
            }
        });
    }
    
    /**
     * Submit a response for a specific PDF form request token.
     * Equivalent to v2 /response/submit endpoint.
     * @param data The data for the request.
     * @param data.token Request token
     * @param data.requestBody
     * @returns RequestForm
     * @throws ApiError
     */
    public static formsPdfFormSubmitCreate(data: FormsPdfFormSubmitCreateData): CancelablePromise<FormsPdfFormSubmitCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/forms/pdf-form/{token}/submit/',
            path: {
                token: data.token
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Create a third-party document link for a case and form. Equivalent to v2 /third-party/link endpoint.
     * @param data The data for the request.
     * @param data.formData
     * @returns ThirdPartyDocumentLinkResponse
     * @throws ApiError
     */
    public static formsThirdPartyLinkCreate(data: FormsThirdPartyLinkCreateData): CancelablePromise<FormsThirdPartyLinkCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/forms/third-party/link/',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
}

export class HubspotService {
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot companies.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedSuperUserHubSpotCompanyList
     * @throws ApiError
     */
    public static hubspotCompaniesList(data: HubspotCompaniesListData = {}): CancelablePromise<HubspotCompaniesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/hubspot/companies/',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot companies.
     * @returns SuperUserHubSpotCompany
     * @throws ApiError
     */
    public static hubspotCompaniesCreate(): CancelablePromise<HubspotCompaniesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/hubspot/companies/'
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot companies.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns SuperUserHubSpotCompany
     * @throws ApiError
     */
    public static hubspotCompaniesRetrieve(data: HubspotCompaniesRetrieveData): CancelablePromise<HubspotCompaniesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/hubspot/companies/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot companies.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SuperUserHubSpotCompany
     * @throws ApiError
     */
    public static hubspotCompaniesUpdate(data: HubspotCompaniesUpdateData): CancelablePromise<HubspotCompaniesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/hubspot/companies/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot companies.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SuperUserHubSpotCompany
     * @throws ApiError
     */
    public static hubspotCompaniesPartialUpdate(data: HubspotCompaniesPartialUpdateData): CancelablePromise<HubspotCompaniesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/hubspot/companies/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot companies.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SuperUserHubSpotCompany
     * @throws ApiError
     */
    public static hubspotCompaniesDestroy(data: HubspotCompaniesDestroyData): CancelablePromise<HubspotCompaniesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/hubspot/companies/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Fetch onboarding data from HubSpot for a company and its associated contacts. Returns company details (name, phone, address) and contact information (first name, last name, email, phone) to prefill customer creation forms.
     * @param data The data for the request.
     * @param data.uuid
     * @returns HubSpotCompanyOnboardingData
     * @throws ApiError
     */
    public static hubspotCompaniesOnboardingDataRetrieve(data: HubspotCompaniesOnboardingDataRetrieveData): CancelablePromise<HubspotCompaniesOnboardingDataRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/hubspot/companies/{uuid}/onboarding-data/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Find potential HubSpot company matches for an organisation.
     *
     * Searches for HubSpot companies based on:
     * - The organisation's email domain
     * - Email domains of users belonging to the organisation
     *
     * Returns a list of potential HubSpot company candidates with
     * information about which domains matched.
     *
     * :param request: The HTTP request containing organisation_uuid query param
     * :return: List of HubSpot company candidates with match metadata
     * @param data The data for the request.
     * @param data.organisationUuid UUID of the organisation to find HubSpot companies for
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedHubSpotCompanyCandidateList
     * @throws ApiError
     */
    public static hubspotCompaniesFindForOrganisationList(data: HubspotCompaniesFindForOrganisationListData): CancelablePromise<HubspotCompaniesFindForOrganisationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/hubspot/companies/find-for-organisation/',
            query: {
                limit: data.limit,
                offset: data.offset,
                organisation_uuid: data.organisationUuid,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot contacts.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedSuperUserHubSpotContactList
     * @throws ApiError
     */
    public static hubspotContactsList(data: HubspotContactsListData = {}): CancelablePromise<HubspotContactsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/hubspot/contacts/',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot contacts.
     * @returns SuperUserHubSpotContact
     * @throws ApiError
     */
    public static hubspotContactsCreate(): CancelablePromise<HubspotContactsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/hubspot/contacts/'
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot contacts.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns SuperUserHubSpotContact
     * @throws ApiError
     */
    public static hubspotContactsRetrieve(data: HubspotContactsRetrieveData): CancelablePromise<HubspotContactsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/hubspot/contacts/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot contacts.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SuperUserHubSpotContact
     * @throws ApiError
     */
    public static hubspotContactsUpdate(data: HubspotContactsUpdateData): CancelablePromise<HubspotContactsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/hubspot/contacts/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot contacts.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SuperUserHubSpotContact
     * @throws ApiError
     */
    public static hubspotContactsPartialUpdate(data: HubspotContactsPartialUpdateData): CancelablePromise<HubspotContactsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/hubspot/contacts/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing ~~and editing~~ hubspot contacts.
     * @param data The data for the request.
     * @param data.uuid
     * @returns SuperUserHubSpotContact
     * @throws ApiError
     */
    public static hubspotContactsDestroy(data: HubspotContactsDestroyData): CancelablePromise<HubspotContactsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/hubspot/contacts/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class InboundEmailsService {
    /**
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedTInboundEmailList
     * @throws ApiError
     */
    public static inboundEmailsList(data: InboundEmailsListData = {}): CancelablePromise<InboundEmailsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/inbound_emails/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TInboundEmail
     * @throws ApiError
     */
    public static inboundEmailsCreate(data: InboundEmailsCreateData = {}): CancelablePromise<InboundEmailsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/inbound_emails/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TInboundEmail
     * @throws ApiError
     */
    public static inboundEmailsRetrieve(data: InboundEmailsRetrieveData): CancelablePromise<InboundEmailsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/inbound_emails/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TInboundEmail
     * @throws ApiError
     */
    public static inboundEmailsUpdate(data: InboundEmailsUpdateData): CancelablePromise<InboundEmailsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/inbound_emails/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TInboundEmail
     * @throws ApiError
     */
    public static inboundEmailsPartialUpdate(data: InboundEmailsPartialUpdateData): CancelablePromise<InboundEmailsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/inbound_emails/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @returns TInboundEmail
     * @throws ApiError
     */
    public static inboundEmailsDestroy(data: InboundEmailsDestroyData): CancelablePromise<InboundEmailsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/inbound_emails/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Create a case from an inbound email.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static inboundEmailsCreateCaseCreate(data: InboundEmailsCreateCaseCreateData): CancelablePromise<InboundEmailsCreateCaseCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/inbound_emails/{uuid}/create_case/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class JurnodesService {
    /**
     * @returns JurnodesLawCategory
     * @throws ApiError
     */
    public static jurnodesLawCategoriesList(): CancelablePromise<JurnodesLawCategoriesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/jurnodes/law-categories/'
        });
    }
    
    /**
     * @returns JurnodesRecordSchema
     * @throws ApiError
     */
    public static jurnodesRecordSchemasList(): CancelablePromise<JurnodesRecordSchemasListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/jurnodes/record-schemas/'
        });
    }
    
    /**
     * @returns JurnodesUser
     * @throws ApiError
     */
    public static jurnodesUsersList(): CancelablePromise<JurnodesUsersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/jurnodes/users/'
        });
    }
    
}

export class KleosService {
    /**
     * @returns KleosCaseTypes
     * @throws ApiError
     */
    public static kleosCaseTypesRetrieve(): CancelablePromise<KleosCaseTypesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/kleos/case-types/',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
}

export class KleosOauthService {
    /**
     * Initiates the Kleos OAuth2 authorization flow.
     * @throws ApiError
     */
    public static kleosOauthAuthorizeRetrieve(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/kleos_oauth/authorize/',
            errors: {
                302: 'No response body'
            }
        });
    }
    
    /**
     * Logs out from Kleos by clearing tokens.
     * @returns unknown No response body
     * @throws ApiError
     */
    public static kleosOauthLogoutCreate(): CancelablePromise<KleosOauthLogoutCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/kleos_oauth/logout/'
        });
    }
    
}

export class LawFieldsService {
    /**
     * Retrieve available law fields based on user's organisation jurisdiction
     * @returns LawFields
     * @throws ApiError
     */
    public static lawFieldsRetrieve(): CancelablePromise<LawFieldsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/law_fields/'
        });
    }
    
}

export class OnboardingPackagesService {
    /**
     * @param data The data for the request.
     * @param data.lawField
     * @param data.lawTopic
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedTOnboardingPackageList
     * @throws ApiError
     */
    public static onboardingPackagesList(data: OnboardingPackagesListData = {}): CancelablePromise<OnboardingPackagesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/onboarding_packages/',
            query: {
                law_field: data.lawField,
                law_topic: data.lawTopic,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TOnboardingPackage
     * @throws ApiError
     */
    public static onboardingPackagesCreate(data: OnboardingPackagesCreateData = {}): CancelablePromise<OnboardingPackagesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/onboarding_packages/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TOnboardingPackage
     * @throws ApiError
     */
    public static onboardingPackagesRetrieve(data: OnboardingPackagesRetrieveData): CancelablePromise<OnboardingPackagesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/onboarding_packages/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TOnboardingPackage
     * @throws ApiError
     */
    public static onboardingPackagesUpdate(data: OnboardingPackagesUpdateData): CancelablePromise<OnboardingPackagesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/onboarding_packages/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TOnboardingPackage
     * @throws ApiError
     */
    public static onboardingPackagesPartialUpdate(data: OnboardingPackagesPartialUpdateData): CancelablePromise<OnboardingPackagesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/onboarding_packages/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @returns TOnboardingPackage
     * @throws ApiError
     */
    public static onboardingPackagesDestroy(data: OnboardingPackagesDestroyData): CancelablePromise<OnboardingPackagesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/onboarding_packages/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class OnboardingSessionsService {
    /**
     * Start either a legacy form or new PDF form template.
     * Accepts either form_id (legacy) or pdf_form_template_uuid (new).
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns StartFormResponse
     * @throws ApiError
     */
    public static onboardingSessionsStartFormCreate(data: OnboardingSessionsStartFormCreateData): CancelablePromise<OnboardingSessionsStartFormCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/onboarding_sessions/{uuid}/start-form/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns QuestionnaireSubmission
     * @throws ApiError
     */
    public static onboardingSessionsStartQuestionnaireCreate(data: OnboardingSessionsStartQuestionnaireCreateData): CancelablePromise<OnboardingSessionsStartQuestionnaireCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/onboarding_sessions/{uuid}/start-questionnaire/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sessionToken Session token to retrieve the onboarding session
     * @returns OnboardingPackageSessionDetail
     * @throws ApiError
     */
    public static onboardingSessionsByTokenRetrieve(data: OnboardingSessionsByTokenRetrieveData): CancelablePromise<OnboardingSessionsByTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/onboarding_sessions/by-token/',
            query: {
                session_token: data.sessionToken
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OnboardingPackageSession
     * @throws ApiError
     */
    public static onboardingSessionsCreateFromPackageCreate(data: OnboardingSessionsCreateFromPackageCreateData): CancelablePromise<OnboardingSessionsCreateFromPackageCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/onboarding_sessions/create-from-package/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class OrganisationsService {
    /**
     * An API endpoint for viewing and editing organisations.
     * @param data The data for the request.
     * @param data.hasHubspot Has HubSpot Connection
     * @param data.hasIntegrityErrors Has Integrity Errors
     * @param data.hasPhonebotSubscription Has Phonebot Subscription
     * @param data.hasPlatform Has Platform
     * @param data.hasPlatformSubscription Has Platform Subscription
     * @param data.hasStripe Has Stripe Connection
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.phonebotType Phonebot Type
     * @param data.search A search term.
     * @returns PaginatedTOrganisationList
     * @throws ApiError
     */
    public static organisationsList(data: OrganisationsListData = {}): CancelablePromise<OrganisationsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/organisations/',
            query: {
                has_hubspot: data.hasHubspot,
                has_integrity_errors: data.hasIntegrityErrors,
                has_phonebot_subscription: data.hasPhonebotSubscription,
                has_platform: data.hasPlatform,
                has_platform_subscription: data.hasPlatformSubscription,
                has_stripe: data.hasStripe,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                phonebot_type: data.phonebotType,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing organisations.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TOrganisation
     * @throws ApiError
     */
    public static organisationsCreate(data: OrganisationsCreateData = {}): CancelablePromise<OrganisationsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/organisations/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing organisations.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TOrganisation
     * @throws ApiError
     */
    public static organisationsRetrieve(data: OrganisationsRetrieveData): CancelablePromise<OrganisationsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/organisations/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing organisations.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TOrganisation
     * @throws ApiError
     */
    public static organisationsUpdate(data: OrganisationsUpdateData): CancelablePromise<OrganisationsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/organisations/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing organisations.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TOrganisation
     * @throws ApiError
     */
    public static organisationsPartialUpdate(data: OrganisationsPartialUpdateData): CancelablePromise<OrganisationsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/organisations/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing organisations.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TOrganisation
     * @throws ApiError
     */
    public static organisationsDestroy(data: OrganisationsDestroyData): CancelablePromise<OrganisationsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/organisations/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * List organisation employees
     * Returns a paginated list of all employees in the organisation
     * @param data The data for the request.
     * @param data.uuid
     * @param data.hasHubspot Has HubSpot Connection
     * @param data.hasIntegrityErrors Has Integrity Errors
     * @param data.hasPhonebotSubscription Has Phonebot Subscription
     * @param data.hasPlatform Has Platform
     * @param data.hasPlatformSubscription Has Platform Subscription
     * @param data.hasStripe Has Stripe Connection
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.phonebotType Phonebot Type
     * @param data.role Filter by role. Accepts: ADMIN, LAWYER, CLERK
     * @param data.search A search term.
     * @returns PaginatedOrganisationEmployeeList
     * @throws ApiError
     */
    public static organisationsEmployeesList(data: OrganisationsEmployeesListData): CancelablePromise<OrganisationsEmployeesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/organisations/{uuid}/employees/',
            path: {
                uuid: data.uuid
            },
            query: {
                has_hubspot: data.hasHubspot,
                has_integrity_errors: data.hasIntegrityErrors,
                has_phonebot_subscription: data.hasPhonebotSubscription,
                has_platform: data.hasPlatform,
                has_platform_subscription: data.hasPlatformSubscription,
                has_stripe: data.hasStripe,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                phonebot_type: data.phonebotType,
                role: data.role,
                search: data.search
            },
            errors: {
                403: ''
            }
        });
    }
    
    /**
     * Remove employee from organisation
     * Removes an employee from the organisation and reassigns their cases
     * @param data The data for the request.
     * @param data.employeeUuid
     * @param data.uuid
     * @param data.requestBody
     * @returns void No response body
     * @throws ApiError
     */
    public static organisationsEmployeesRemoveCreate(data: OrganisationsEmployeesRemoveCreateData): CancelablePromise<OrganisationsEmployeesRemoveCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/organisations/{uuid}/employees/{employee_uuid}/remove/',
            path: {
                employee_uuid: data.employeeUuid,
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Create new employee
     * Creates a new user and adds them to the organisation
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns OrganisationEmployee
     * @throws ApiError
     */
    public static organisationsEmployeesCreateCreate(data: OrganisationsEmployeesCreateCreateData): CancelablePromise<OrganisationsEmployeesCreateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/organisations/{uuid}/employees/create/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
    /**
     * Run integrity check
     * Run integrity checks on the organisation and save results. Only available to superusers.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.hasHubspot Has HubSpot Connection
     * @param data.hasIntegrityErrors Has Integrity Errors
     * @param data.hasPhonebotSubscription Has Phonebot Subscription
     * @param data.hasPlatform Has Platform
     * @param data.hasPlatformSubscription Has Platform Subscription
     * @param data.hasStripe Has Stripe Connection
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.phonebotType Phonebot Type
     * @param data.search A search term.
     * @param data.requestBody
     * @returns PaginatedIntegrityCheckList
     * @throws ApiError
     */
    public static organisationsRunIntegrityCheckCreate(data: OrganisationsRunIntegrityCheckCreateData): CancelablePromise<OrganisationsRunIntegrityCheckCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/organisations/{uuid}/run-integrity-check/',
            path: {
                uuid: data.uuid
            },
            query: {
                has_hubspot: data.hasHubspot,
                has_integrity_errors: data.hasIntegrityErrors,
                has_phonebot_subscription: data.hasPhonebotSubscription,
                has_platform: data.hasPlatform,
                has_platform_subscription: data.hasPlatformSubscription,
                has_stripe: data.hasStripe,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                phonebot_type: data.phonebotType,
                search: data.search
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Update organisation logo
     * Updates the organisation's logo. Accepts PNG, JPG, or GIF files.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns unknown No response body
     * @throws ApiError
     */
    public static organisationsUpdateLogoCreate(data: OrganisationsUpdateLogoCreateData): CancelablePromise<OrganisationsUpdateLogoCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/organisations/{uuid}/update-logo/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Get an organisation by its org_token (questionnaire creation token).
     * This is used for standalone questionnaires where we need to show the org card.
     * @returns TOrganisation
     * @throws ApiError
     */
    public static organisationsByOrgTokenRetrieve(): CancelablePromise<OrganisationsByOrgTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/organisations/by-org-token/'
        });
    }
    
    /**
     * Get a lightweight list of all organisations with only uuid and name.
     * Used for dropdowns and selection lists. Only available to superusers.
     * @param data The data for the request.
     * @param data.hasHubspot Has HubSpot Connection
     * @param data.hasIntegrityErrors Has Integrity Errors
     * @param data.hasPhonebotSubscription Has Phonebot Subscription
     * @param data.hasPlatform Has Platform
     * @param data.hasPlatformSubscription Has Platform Subscription
     * @param data.hasStripe Has Stripe Connection
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.phonebotType Phonebot Type
     * @param data.search A search term.
     * @returns PaginatedMinimalOrganisationList
     * @throws ApiError
     */
    public static organisationsOrganisationsListList(data: OrganisationsOrganisationsListListData = {}): CancelablePromise<OrganisationsOrganisationsListListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/organisations/organisations-list/',
            query: {
                has_hubspot: data.hasHubspot,
                has_integrity_errors: data.hasIntegrityErrors,
                has_phonebot_subscription: data.hasPhonebotSubscription,
                has_platform: data.hasPlatform,
                has_platform_subscription: data.hasPlatformSubscription,
                has_stripe: data.hasStripe,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                phonebot_type: data.phonebotType,
                search: data.search
            }
        });
    }
    
}

export class PdfFormSubmissionsService {
    /**
     * ViewSet for managing PDF form template submissions.
     *
     * Provides CRUD operations for form submissions with simplified JSON-based
     * field storage for better performance and flexibility.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedTPDFFormSubmissionList
     * @throws ApiError
     */
    public static pdfFormSubmissionsList(data: PdfFormSubmissionsListData = {}): CancelablePromise<PdfFormSubmissionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/pdf_form_submissions/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * ViewSet for managing PDF form template submissions.
     *
     * Provides CRUD operations for form submissions with simplified JSON-based
     * field storage for better performance and flexibility.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TPDFFormSubmission
     * @throws ApiError
     */
    public static pdfFormSubmissionsCreate(data: PdfFormSubmissionsCreateData = {}): CancelablePromise<PdfFormSubmissionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/pdf_form_submissions/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing PDF form template submissions.
     *
     * Provides CRUD operations for form submissions with simplified JSON-based
     * field storage for better performance and flexibility.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TPDFFormSubmission
     * @throws ApiError
     */
    public static pdfFormSubmissionsRetrieve(data: PdfFormSubmissionsRetrieveData): CancelablePromise<PdfFormSubmissionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/pdf_form_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * ViewSet for managing PDF form template submissions.
     *
     * Provides CRUD operations for form submissions with simplified JSON-based
     * field storage for better performance and flexibility.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPDFFormSubmission
     * @throws ApiError
     */
    public static pdfFormSubmissionsUpdate(data: PdfFormSubmissionsUpdateData): CancelablePromise<PdfFormSubmissionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/pdf_form_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing PDF form template submissions.
     *
     * Provides CRUD operations for form submissions with simplified JSON-based
     * field storage for better performance and flexibility.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPDFFormSubmission
     * @throws ApiError
     */
    public static pdfFormSubmissionsPartialUpdate(data: PdfFormSubmissionsPartialUpdateData): CancelablePromise<PdfFormSubmissionsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/pdf_form_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing PDF form template submissions.
     *
     * Provides CRUD operations for form submissions with simplified JSON-based
     * field storage for better performance and flexibility.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TPDFFormSubmission
     * @throws ApiError
     */
    public static pdfFormSubmissionsDestroy(data: PdfFormSubmissionsDestroyData): CancelablePromise<PdfFormSubmissionsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/pdf_form_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Get PDF form submission by access token
     * Retrieve a PDF form submission and its associated case using a third-party access token. This endpoint is used by the client portal to load submission and case data.
     * @param data The data for the request.
     * @param data.accessToken Third-party access token for the PDF form submission
     * @returns TPDFFormSubmissionWithCase
     * @throws ApiError
     */
    public static pdfFormSubmissionsByAccessTokenRetrieve(data: PdfFormSubmissionsByAccessTokenRetrieveData = {}): CancelablePromise<PdfFormSubmissionsByAccessTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/pdf_form_submissions/by-access-token/',
            query: {
                access_token: data.accessToken
            },
            errors: {
                400: '',
                404: ''
            }
        });
    }
    
    /**
     * Create external PDF form submission
     * Create an external PDF form submission linked to an existing case. The submission will be prefilled with case data and accessible via a third-party token. Only available for lawfirm employees.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ExternalPDFFormSubmissionResponse
     * @throws ApiError
     */
    public static pdfFormSubmissionsExternalCreate(data: PdfFormSubmissionsExternalCreateData): CancelablePromise<PdfFormSubmissionsExternalCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/pdf_form_submissions/external/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                404: ''
            }
        });
    }
    
}

export class PdfFormTemplatesService {
    /**
     * An API endpoint for viewing and editing PDF Form Templates.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedTPDFFormTemplateList
     * @throws ApiError
     */
    public static pdfFormTemplatesList(data: PdfFormTemplatesListData = {}): CancelablePromise<PdfFormTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/pdf_form_templates/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing PDF Form Templates.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TPDFFormTemplate
     * @throws ApiError
     */
    public static pdfFormTemplatesCreate(data: PdfFormTemplatesCreateData = {}): CancelablePromise<PdfFormTemplatesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/pdf_form_templates/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing PDF Form Templates.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TPDFFormTemplate
     * @throws ApiError
     */
    public static pdfFormTemplatesRetrieve(data: PdfFormTemplatesRetrieveData): CancelablePromise<PdfFormTemplatesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/pdf_form_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing PDF Form Templates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPDFFormTemplate
     * @throws ApiError
     */
    public static pdfFormTemplatesUpdate(data: PdfFormTemplatesUpdateData): CancelablePromise<PdfFormTemplatesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/pdf_form_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing PDF Form Templates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPDFFormTemplate
     * @throws ApiError
     */
    public static pdfFormTemplatesPartialUpdate(data: PdfFormTemplatesPartialUpdateData): CancelablePromise<PdfFormTemplatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/pdf_form_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing PDF Form Templates.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TPDFFormTemplate
     * @throws ApiError
     */
    public static pdfFormTemplatesDestroy(data: PdfFormTemplatesDestroyData): CancelablePromise<PdfFormTemplatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/pdf_form_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Copy a specific instance of a PDF form template.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPDFFormTemplate
     * @throws ApiError
     */
    public static pdfFormTemplatesCopyCreate(data: PdfFormTemplatesCopyCreateData): CancelablePromise<PdfFormTemplatesCopyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/pdf_form_templates/{uuid}/copy/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Replace PDF document
     * Replace the PDF document while keeping existing form fields unchanged
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns unknown
     * @throws ApiError
     */
    public static pdfFormTemplatesReplaceDocumentCreate(data: PdfFormTemplatesReplaceDocumentCreateData): CancelablePromise<PdfFormTemplatesReplaceDocumentCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/pdf_form_templates/{uuid}/replace-document/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: ''
            }
        });
    }
    
}

export class PhoneForwardingRulesService {
    /**
     * ViewSet for managing phone forwarding rules.
     *
     * Permissions:
     * - Customer admins and higher can create, update, delete
     * - Customers and phonebot can view
     * @param data The data for the request.
     * @param data.active Filter by active status
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.ruleType Filter by rule type (phonenumber, entity, text)
     * @param data.search Search term for title, forwarding message, target phone number, or text context
     * @returns PaginatedTPhoneForwardingRuleList
     * @throws ApiError
     */
    public static phoneForwardingRulesList(data: PhoneForwardingRulesListData = {}): CancelablePromise<PhoneForwardingRulesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/phone_forwarding_rules/',
            query: {
                active: data.active,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                rule_type: data.ruleType,
                search: data.search
            }
        });
    }
    
    /**
     * ViewSet for managing phone forwarding rules.
     *
     * Permissions:
     * - Customer admins and higher can create, update, delete
     * - Customers and phonebot can view
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PhoneForwardingRule
     * @throws ApiError
     */
    public static phoneForwardingRulesCreate(data: PhoneForwardingRulesCreateData): CancelablePromise<PhoneForwardingRulesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/phone_forwarding_rules/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing phone forwarding rules.
     *
     * Permissions:
     * - Customer admins and higher can create, update, delete
     * - Customers and phonebot can view
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @param data.active Filter by active status
     * @param data.ruleType Filter by rule type (phonenumber, entity, text)
     * @param data.search Search term for title, forwarding message, target phone number, or text context
     * @returns TPhoneForwardingRule
     * @throws ApiError
     */
    public static phoneForwardingRulesRetrieve(data: PhoneForwardingRulesRetrieveData): CancelablePromise<PhoneForwardingRulesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/phone_forwarding_rules/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                active: data.active,
                rule_type: data.ruleType,
                search: data.search
            }
        });
    }
    
    /**
     * ViewSet for managing phone forwarding rules.
     *
     * Permissions:
     * - Customer admins and higher can create, update, delete
     * - Customers and phonebot can view
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns PhoneForwardingRule
     * @throws ApiError
     */
    public static phoneForwardingRulesUpdate(data: PhoneForwardingRulesUpdateData): CancelablePromise<PhoneForwardingRulesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/phone_forwarding_rules/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing phone forwarding rules.
     *
     * Permissions:
     * - Customer admins and higher can create, update, delete
     * - Customers and phonebot can view
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns PhoneForwardingRule
     * @throws ApiError
     */
    public static phoneForwardingRulesPartialUpdate(data: PhoneForwardingRulesPartialUpdateData): CancelablePromise<PhoneForwardingRulesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/phone_forwarding_rules/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * ViewSet for managing phone forwarding rules.
     *
     * Permissions:
     * - Customer admins and higher can create, update, delete
     * - Customers and phonebot can view
     * @param data The data for the request.
     * @param data.uuid
     * @returns PhoneForwardingRule
     * @throws ApiError
     */
    public static phoneForwardingRulesDestroy(data: PhoneForwardingRulesDestroyData): CancelablePromise<PhoneForwardingRulesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/phone_forwarding_rules/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class PhoneNumbersService {
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedTPhoneNumberList
     * @throws ApiError
     */
    public static phoneNumbersList(data: PhoneNumbersListData = {}): CancelablePromise<PhoneNumbersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/phone_numbers/',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TPhoneNumber
     * @throws ApiError
     */
    public static phoneNumbersCreate(data: PhoneNumbersCreateData = {}): CancelablePromise<PhoneNumbersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/phone_numbers/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TPhoneNumber
     * @throws ApiError
     */
    public static phoneNumbersRetrieve(data: PhoneNumbersRetrieveData): CancelablePromise<PhoneNumbersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/phone_numbers/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPhoneNumber
     * @throws ApiError
     */
    public static phoneNumbersUpdate(data: PhoneNumbersUpdateData): CancelablePromise<PhoneNumbersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/phone_numbers/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TPhoneNumber
     * @throws ApiError
     */
    public static phoneNumbersPartialUpdate(data: PhoneNumbersPartialUpdateData): CancelablePromise<PhoneNumbersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/phone_numbers/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TPhoneNumber
     * @throws ApiError
     */
    public static phoneNumbersDestroy(data: PhoneNumbersDestroyData): CancelablePromise<PhoneNumbersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/phone_numbers/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class PlaceholdersService {
    /**
     * @returns Placeholder
     * @throws ApiError
     */
    public static placeholdersList(): CancelablePromise<PlaceholdersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/placeholders'
        });
    }
    
}

export class ProposedEntityChangesService {
    /**
     * Accept a proposed entity change. This will apply the proposed value to the entity field and mark the proposal as accepted.
     * @param data The data for the request.
     * @param data.uuid
     * @returns CustomerEntity
     * @throws ApiError
     */
    public static proposedEntityChangesAcceptCreate(data: ProposedEntityChangesAcceptCreateData): CancelablePromise<ProposedEntityChangesAcceptCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/proposed-entity-changes/{uuid}/accept/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Reject a proposed entity change. This will mark the proposal as rejected without applying any changes to the entity.
     * @param data The data for the request.
     * @param data.uuid
     * @returns CustomerEntity
     * @throws ApiError
     */
    public static proposedEntityChangesRejectCreate(data: ProposedEntityChangesRejectCreateData): CancelablePromise<ProposedEntityChangesRejectCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/proposed-entity-changes/{uuid}/reject/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class QuestionnaireSubmissionsService {
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTQuestionnaireSubmissionList
     * @throws ApiError
     */
    public static questionnaireSubmissionsList(data: QuestionnaireSubmissionsListData = {}): CancelablePromise<QuestionnaireSubmissionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/questionnaire_submissions/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TQuestionnaireSubmission
     * @throws ApiError
     */
    public static questionnaireSubmissionsCreate(data: QuestionnaireSubmissionsCreateData = {}): CancelablePromise<QuestionnaireSubmissionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaire_submissions/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TQuestionnaireSubmission
     * @throws ApiError
     */
    public static questionnaireSubmissionsRetrieve(data: QuestionnaireSubmissionsRetrieveData): CancelablePromise<QuestionnaireSubmissionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/questionnaire_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TQuestionnaireSubmission
     * @throws ApiError
     */
    public static questionnaireSubmissionsUpdate(data: QuestionnaireSubmissionsUpdateData): CancelablePromise<QuestionnaireSubmissionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/questionnaire_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TQuestionnaireSubmission
     * @throws ApiError
     */
    public static questionnaireSubmissionsPartialUpdate(data: QuestionnaireSubmissionsPartialUpdateData): CancelablePromise<QuestionnaireSubmissionsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/questionnaire_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TQuestionnaireSubmission
     * @throws ApiError
     */
    public static questionnaireSubmissionsDestroy(data: QuestionnaireSubmissionsDestroyData): CancelablePromise<QuestionnaireSubmissionsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/questionnaire_submissions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Delete a file from a questionnaire submission.
     * @param data The data for the request.
     * @param data.uuid
     * @returns void No response body
     * @throws ApiError
     */
    public static questionnaireSubmissionsDeleteFileDestroy(data: QuestionnaireSubmissionsDeleteFileDestroyData): CancelablePromise<QuestionnaireSubmissionsDeleteFileDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/questionnaire_submissions/{uuid}/delete-file/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Upload a file to a questionnaire submission field.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns FileUploadResponse
     * @throws ApiError
     */
    public static questionnaireSubmissionsUploadFileCreate(data: QuestionnaireSubmissionsUploadFileCreateData): CancelablePromise<QuestionnaireSubmissionsUploadFileCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaire_submissions/{uuid}/upload-file/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaire submissions.
     * Supports lookup by both short_id and uuid.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ExternalQuestionnaireSubmissionResponse
     * @throws ApiError
     */
    public static questionnaireSubmissionsCreateExternalCreate(data: QuestionnaireSubmissionsCreateExternalCreateData): CancelablePromise<QuestionnaireSubmissionsCreateExternalCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaire_submissions/create_external/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class QuestionnairesService {
    /**
     * An API endpoint for viewing and editing questionnaires.
     * @param data The data for the request.
     * @param data.isJupusTemplate
     * @param data.lawField
     * @param data.lawTopic
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @returns PaginatedTQuestionnaireList
     * @throws ApiError
     */
    public static questionnairesList(data: QuestionnairesListData = {}): CancelablePromise<QuestionnairesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/questionnaires/',
            query: {
                is_jupus_template: data.isJupusTemplate,
                law_field: data.lawField,
                law_topic: data.lawTopic,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaires.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesCreate(data: QuestionnairesCreateData = {}): CancelablePromise<QuestionnairesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaires/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaires.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesRetrieve(data: QuestionnairesRetrieveData): CancelablePromise<QuestionnairesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/questionnaires/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaires.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesUpdate(data: QuestionnairesUpdateData): CancelablePromise<QuestionnairesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/questionnaires/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaires.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesPartialUpdate(data: QuestionnairesPartialUpdateData): CancelablePromise<QuestionnairesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/questionnaires/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing questionnaires.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesDestroy(data: QuestionnairesDestroyData): CancelablePromise<QuestionnairesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/questionnaires/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Copy a specific instance of a questionnaire.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesCopyCreate(data: QuestionnairesCopyCreateData): CancelablePromise<QuestionnairesCopyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaires/{uuid}/copy/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Generate a questionnaire based on AI analysis.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesGenerateCreate(data: QuestionnairesGenerateCreateData): CancelablePromise<QuestionnairesGenerateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaires/{uuid}/generate/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Generate an AI-powered title suggestion for a questionnaire.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TQuestionnaire
     * @throws ApiError
     */
    public static questionnairesGenerateTitleCreate(data: QuestionnairesGenerateTitleCreateData): CancelablePromise<QuestionnairesGenerateTitleCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaires/{uuid}/generate-title/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Create a third-party questionnaire submission.
     * Only available for lawfirm employees.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns QuestionnaireSubmission
     * @throws ApiError
     */
    public static questionnairesThirdPartyCreate(data: QuestionnairesThirdPartyCreateData): CancelablePromise<QuestionnairesThirdPartyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/questionnaires/third-party/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class RetellAgentsService {
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedTRetellAgentList
     * @throws ApiError
     */
    public static retellAgentsList(data: RetellAgentsListData = {}): CancelablePromise<RetellAgentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/retell_agents/',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TRetellAgent
     * @throws ApiError
     */
    public static retellAgentsCreate(data: RetellAgentsCreateData = {}): CancelablePromise<RetellAgentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/retell_agents/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TRetellAgent
     * @throws ApiError
     */
    public static retellAgentsRetrieve(data: RetellAgentsRetrieveData): CancelablePromise<RetellAgentsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/retell_agents/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TRetellAgent
     * @throws ApiError
     */
    public static retellAgentsUpdate(data: RetellAgentsUpdateData): CancelablePromise<RetellAgentsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/retell_agents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TRetellAgent
     * @throws ApiError
     */
    public static retellAgentsPartialUpdate(data: RetellAgentsPartialUpdateData): CancelablePromise<RetellAgentsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/retell_agents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * This mixin allows you to use multiple fields for lookup in the viewset.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TRetellAgent
     * @throws ApiError
     */
    public static retellAgentsDestroy(data: RetellAgentsDestroyData): CancelablePromise<RetellAgentsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/retell_agents/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class SavedResponsesService {
    /**
     * List saved responses
     * Retrieve a list of saved responses for the user's organization. Supports filtering by session_type (CASE or GLOBAL), searching by title/content, and ordering by created_at or title.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Order results by field
     * @param data.search Search in title and content
     * @param data.sessionType Filter by session type
     * @returns PaginatedTSavedResponseList
     * @throws ApiError
     */
    public static savedResponsesList(data: SavedResponsesListData = {}): CancelablePromise<SavedResponsesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/saved_responses/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                session_type: data.sessionType
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Saved Responses.
     * @param data The data for the request.
     * @param data.sessionType Filter saved responses by session type
     * @param data.requestBody
     * @returns TSavedResponse
     * @throws ApiError
     */
    public static savedResponsesCreate(data: SavedResponsesCreateData = {}): CancelablePromise<SavedResponsesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/saved_responses/',
            query: {
                session_type: data.sessionType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Saved Responses.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @param data.sessionType Filter saved responses by session type
     * @returns TSavedResponse
     * @throws ApiError
     */
    public static savedResponsesRetrieve(data: SavedResponsesRetrieveData): CancelablePromise<SavedResponsesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/saved_responses/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                session_type: data.sessionType
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Saved Responses.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.sessionType Filter saved responses by session type
     * @param data.requestBody
     * @returns TSavedResponse
     * @throws ApiError
     */
    public static savedResponsesUpdate(data: SavedResponsesUpdateData): CancelablePromise<SavedResponsesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/saved_responses/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                session_type: data.sessionType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Saved Responses.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.sessionType Filter saved responses by session type
     * @param data.requestBody
     * @returns TSavedResponse
     * @throws ApiError
     */
    public static savedResponsesPartialUpdate(data: SavedResponsesPartialUpdateData): CancelablePromise<SavedResponsesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/saved_responses/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                session_type: data.sessionType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Saved Responses.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.sessionType Filter saved responses by session type
     * @returns TSavedResponse
     * @throws ApiError
     */
    public static savedResponsesDestroy(data: SavedResponsesDestroyData): CancelablePromise<SavedResponsesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/saved_responses/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                session_type: data.sessionType
            }
        });
    }
    
    /**
     * Generate a title for a saved response based on its content.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.sessionType Filter saved responses by session type
     * @returns GenerateTitleResponse
     * @throws ApiError
     */
    public static savedResponsesGenerateTitleCreate(data: SavedResponsesGenerateTitleCreateData): CancelablePromise<SavedResponsesGenerateTitleCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/saved_responses/generate_title/',
            query: {
                session_type: data.sessionType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class ServicesService {
    /**
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.orgSlug
     * @returns PaginatedTServiceList
     * @throws ApiError
     */
    public static servicesList(data: ServicesListData = {}): CancelablePromise<ServicesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/services/',
            query: {
                limit: data.limit,
                offset: data.offset,
                org__slug: data.orgSlug
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TService
     * @throws ApiError
     */
    public static servicesCreate(data: ServicesCreateData = {}): CancelablePromise<ServicesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/services/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TService
     * @throws ApiError
     */
    public static servicesRetrieve(data: ServicesRetrieveData): CancelablePromise<ServicesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/services/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TService
     * @throws ApiError
     */
    public static servicesUpdate(data: ServicesUpdateData): CancelablePromise<ServicesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/services/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TService
     * @throws ApiError
     */
    public static servicesPartialUpdate(data: ServicesPartialUpdateData): CancelablePromise<ServicesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/services/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @returns TService
     * @throws ApiError
     */
    public static servicesDestroy(data: ServicesDestroyData): CancelablePromise<ServicesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/services/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Returns the availabilities for the service
     * @param data The data for the request.
     * @param data.calendarSlug
     * @param data.uuid
     * @param data.requestBody
     * @returns TService
     * @throws ApiError
     */
    public static servicesAvailabilitiesCreate(data: ServicesAvailabilitiesCreateData): CancelablePromise<ServicesAvailabilitiesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/services/{uuid}/{calendar_slug}/availabilities/',
            path: {
                calendar_slug: data.calendarSlug,
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class SettingsService {
    /**
     * Retrieve the Actaport settings for the organization.
     * @returns ActaportSettings
     * @throws ApiError
     */
    public static settingsActaportList(): CancelablePromise<SettingsActaportListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/actaport/'
        });
    }
    
    /**
     * Update the Actaport settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ActaportSettings
     * @throws ApiError
     */
    public static settingsActaportCreate(data: SettingsActaportCreateData = {}): CancelablePromise<SettingsActaportCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/actaport/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for retrieving and updating Actaport integration settings.
     * @returns unknown
     * @throws ApiError
     */
    public static settingsActaportSyncUpdate(): CancelablePromise<SettingsActaportSyncUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/settings/actaport/sync/',
            errors: {
                403: ''
            }
        });
    }
    
    /**
     * Retrieve the Advolux settings for the organization.
     * @returns AdvoluxSettings
     * @throws ApiError
     */
    public static settingsAdvoluxList(): CancelablePromise<SettingsAdvoluxListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/advolux/'
        });
    }
    
    /**
     * Update the Advolux settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdvoluxSettings
     * @throws ApiError
     */
    public static settingsAdvoluxCreate(data: SettingsAdvoluxCreateData = {}): CancelablePromise<SettingsAdvoluxCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/advolux/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the Advoware settings for the organization.
     * @returns AdvowareSettings
     * @throws ApiError
     */
    public static settingsAdvowareList(): CancelablePromise<SettingsAdvowareListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/advoware/'
        });
    }
    
    /**
     * Update the Advoware settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdvowareSettings
     * @throws ApiError
     */
    public static settingsAdvowareCreate(data: SettingsAdvowareCreateData = {}): CancelablePromise<SettingsAdvowareCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/advoware/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for retrieving and updating Advoware integration settings.
     * @returns unknown
     * @throws ApiError
     */
    public static settingsAdvowareSyncUpdate(): CancelablePromise<SettingsAdvowareSyncUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/settings/advoware/sync/',
            errors: {
                400: '',
                401: '',
                403: ''
            }
        });
    }
    
    /**
     * Retrieve the Email Egress settings for the organization.
     * @returns EmailEgressSettings
     * @throws ApiError
     */
    public static settingsEmailEgressList(): CancelablePromise<SettingsEmailEgressListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/email_egress/'
        });
    }
    
    /**
     * Update the Email Egress settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns EmailEgressSettings
     * @throws ApiError
     */
    public static settingsEmailEgressCreate(data: SettingsEmailEgressCreateData = {}): CancelablePromise<SettingsEmailEgressCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/email_egress/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the HIBP settings for the organization.
     * @returns HibpSettings
     * @throws ApiError
     */
    public static settingsHibpList(): CancelablePromise<SettingsHibpListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/hibp/'
        });
    }
    
    /**
     * Update the HIBP settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns HibpSettings
     * @throws ApiError
     */
    public static settingsHibpCreate(data: SettingsHibpCreateData = {}): CancelablePromise<SettingsHibpCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/hibp/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the HubSpot settings for the organization.
     * @returns HubspotSettings
     * @throws ApiError
     */
    public static settingsHubspotList(): CancelablePromise<SettingsHubspotListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/hubspot/'
        });
    }
    
    /**
     * Update the HubSpot settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns HubspotSettings
     * @throws ApiError
     */
    public static settingsHubspotCreate(data: SettingsHubspotCreateData = {}): CancelablePromise<SettingsHubspotCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/hubspot/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the Iusta settings for the organization.
     * @returns IustaSettings
     * @throws ApiError
     */
    public static settingsIustaList(): CancelablePromise<SettingsIustaListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/iusta/'
        });
    }
    
    /**
     * Update the Iusta settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns IustaSettings
     * @throws ApiError
     */
    public static settingsIustaCreate(data: SettingsIustaCreateData = {}): CancelablePromise<SettingsIustaCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/iusta/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the Jurnodes settings for the organization.
     * @returns JurnodesSettings
     * @throws ApiError
     */
    public static settingsJurnodesList(): CancelablePromise<SettingsJurnodesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/jurnodes/'
        });
    }
    
    /**
     * Update the Jurnodes settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns JurnodesSettings
     * @throws ApiError
     */
    public static settingsJurnodesCreate(data: SettingsJurnodesCreateData = {}): CancelablePromise<SettingsJurnodesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/jurnodes/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API endpoint for retrieving and updating Jurnodes integration settings.
     * @returns unknown
     * @throws ApiError
     */
    public static settingsJurnodesSyncUpdate(): CancelablePromise<SettingsJurnodesSyncUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/settings/jurnodes/sync/',
            errors: {
                403: ''
            }
        });
    }
    
    /**
     * Retrieve the Kleos settings for the organization.
     * @returns KleosSettings
     * @throws ApiError
     */
    public static settingsKleosList(): CancelablePromise<SettingsKleosListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/kleos/'
        });
    }
    
    /**
     * Update the Kleos settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns KleosSettings
     * @throws ApiError
     */
    public static settingsKleosCreate(data: SettingsKleosCreateData = {}): CancelablePromise<SettingsKleosCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/kleos/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the LawFirm settings for the organization.
     * @returns LawfirmSettings
     * @throws ApiError
     */
    public static settingsLawfirmList(): CancelablePromise<SettingsLawfirmListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/lawfirm/'
        });
    }
    
    /**
     * Update the LawFirm settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns LawfirmSettings
     * @throws ApiError
     */
    public static settingsLawfirmCreate(data: SettingsLawfirmCreateData = {}): CancelablePromise<SettingsLawfirmCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/lawfirm/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retrieve the Webhooks settings for the organization.
     * @returns WebhooksSettings
     * @throws ApiError
     */
    public static settingsWebhooksList(): CancelablePromise<SettingsWebhooksListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/settings/webhooks/'
        });
    }
    
    /**
     * Update the Webhooks settings for the organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns WebhooksSettings
     * @throws ApiError
     */
    public static settingsWebhooksCreate(data: SettingsWebhooksCreateData = {}): CancelablePromise<SettingsWebhooksCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/settings/webhooks/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class StaleDocumentsService {
    /**
     * Return paginated results with total count for frontend pagination.
     * @param data The data for the request.
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns PaginatedDocumentList
     * @throws ApiError
     */
    public static staleDocumentsList(data: StaleDocumentsListData = {}): CancelablePromise<StaleDocumentsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stale_documents/',
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                limit: data.limit,
                offset: data.offset,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsCreate(data: StaleDocumentsCreateData = {}): CancelablePromise<StaleDocumentsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stale_documents/',
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsRetrieve(data: StaleDocumentsRetrieveData): CancelablePromise<StaleDocumentsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stale_documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsUpdate(data: StaleDocumentsUpdateData): CancelablePromise<StaleDocumentsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/stale_documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsPartialUpdate(data: StaleDocumentsPartialUpdateData): CancelablePromise<StaleDocumentsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/stale_documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns void No response body
     * @throws ApiError
     */
    public static staleDocumentsDestroy(data: StaleDocumentsDestroyData): CancelablePromise<StaleDocumentsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/stale_documents/{uuid}/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsMarkCompletedCreate(data: StaleDocumentsMarkCompletedCreateData): CancelablePromise<StaleDocumentsMarkCompletedCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stale_documents/{uuid}/mark_completed/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsMarkFailedCreate(data: StaleDocumentsMarkFailedCreateData): CancelablePromise<StaleDocumentsMarkFailedCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stale_documents/{uuid}/mark_failed/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.uuid
     * @param data.caseId Filter by case UUID
     * @param data.documentUuid Filter by specific document UUID
     * @param data.endDate End date for filtering stale documents (YYYY-MM-DD)
     * @param data.hours Number of hours to look back for stale documents (default: 24)
     * @param data.orgId Filter by organization UUID
     * @param data.page Page number for pagination (default: 1)
     * @param data.pageSize Number of results per page (default: 20)
     * @param data.search Search in title, filename, uuid, case_uuid, org name, or customer number
     * @param data.showErrored Show documents with errors instead of stale documents (default: false)
     * @param data.showNeverStarted Show documents that never started metadata enrichment (default: false)
     * @param data.staleThresholdMinutes Minutes after which a document is considered stale (default: 15)
     * @param data.startDate Start date for filtering stale documents (YYYY-MM-DD)
     * @returns Document
     * @throws ApiError
     */
    public static staleDocumentsRetryProcessingCreate(data: StaleDocumentsRetryProcessingCreateData): CancelablePromise<StaleDocumentsRetryProcessingCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stale_documents/{uuid}/retry_processing/',
            path: {
                uuid: data.uuid
            },
            query: {
                case_id: data.caseId,
                document_uuid: data.documentUuid,
                end_date: data.endDate,
                hours: data.hours,
                org_id: data.orgId,
                page: data.page,
                page_size: data.pageSize,
                search: data.search,
                show_errored: data.showErrored,
                show_never_started: data.showNeverStarted,
                stale_threshold_minutes: data.staleThresholdMinutes,
                start_date: data.startDate
            }
        });
    }
    
}

export class StripeCustomersService {
    /**
     * An API endpoint for viewing and editing Stripe Customers.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedTStripeCustomerList
     * @throws ApiError
     */
    public static stripeCustomersList(data: StripeCustomersListData = {}): CancelablePromise<StripeCustomersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_customers/',
            query: {
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * Create a new Stripe customer with address information.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SuperUserStripeCustomer
     * @throws ApiError
     */
    public static stripeCustomersCreate(data: StripeCustomersCreateData): CancelablePromise<StripeCustomersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stripe_customers/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Customers.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TStripeCustomer
     * @throws ApiError
     */
    public static stripeCustomersRetrieve(data: StripeCustomersRetrieveData): CancelablePromise<StripeCustomersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_customers/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Customers.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TStripeCustomer
     * @throws ApiError
     */
    public static stripeCustomersUpdate(data: StripeCustomersUpdateData): CancelablePromise<StripeCustomersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/stripe_customers/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Customers.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TStripeCustomer
     * @throws ApiError
     */
    public static stripeCustomersPartialUpdate(data: StripeCustomersPartialUpdateData): CancelablePromise<StripeCustomersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/stripe_customers/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Customers.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TStripeCustomer
     * @throws ApiError
     */
    public static stripeCustomersDestroy(data: StripeCustomersDestroyData): CancelablePromise<StripeCustomersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/stripe_customers/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Find potential Stripe customer matches for an organisation.
     *
     * Searches for Stripe customers based on:
     * - The organisation's email domain
     * - Email domains of users belonging to the organisation
     *
     * Returns a list of potential Stripe customer candidates with
     * information about which domains matched.
     *
     * :param request: The HTTP request containing organisation_uuid query param
     * :return: List of Stripe customer candidates with match metadata
     * @param data The data for the request.
     * @param data.organisationUuid UUID of the organisation to find Stripe customers for
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search A search term.
     * @returns PaginatedStripeCustomerCandidateList
     * @throws ApiError
     */
    public static stripeCustomersFindForOrganisationList(data: StripeCustomersFindForOrganisationListData): CancelablePromise<StripeCustomersFindForOrganisationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_customers/find-for-organisation/',
            query: {
                limit: data.limit,
                offset: data.offset,
                organisation_uuid: data.organisationUuid,
                search: data.search
            }
        });
    }
    
}

export class StripeInvoicesService {
    /**
     * An API endpoint for viewing and editing Stripe Invoices.
     * @param data The data for the request.
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTStripeInvoiceList
     * @throws ApiError
     */
    public static stripeInvoicesList(data: StripeInvoicesListData = {}): CancelablePromise<StripeInvoicesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_invoices/',
            query: {
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Invoices.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TStripeInvoice
     * @throws ApiError
     */
    public static stripeInvoicesCreate(data: StripeInvoicesCreateData = {}): CancelablePromise<StripeInvoicesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stripe_invoices/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Invoices.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TStripeInvoice
     * @throws ApiError
     */
    public static stripeInvoicesRetrieve(data: StripeInvoicesRetrieveData): CancelablePromise<StripeInvoicesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_invoices/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Invoices.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TStripeInvoice
     * @throws ApiError
     */
    public static stripeInvoicesUpdate(data: StripeInvoicesUpdateData): CancelablePromise<StripeInvoicesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/stripe_invoices/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Invoices.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TStripeInvoice
     * @throws ApiError
     */
    public static stripeInvoicesPartialUpdate(data: StripeInvoicesPartialUpdateData): CancelablePromise<StripeInvoicesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/stripe_invoices/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing Stripe Invoices.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TStripeInvoice
     * @throws ApiError
     */
    public static stripeInvoicesDestroy(data: StripeInvoicesDestroyData): CancelablePromise<StripeInvoicesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/stripe_invoices/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Export invoice data for a specific month and year.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns StripeInvoiceExportResponse
     * @throws ApiError
     */
    public static stripeInvoicesExportCreate(data: StripeInvoicesExportCreateData): CancelablePromise<StripeInvoicesExportCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stripe_invoices/export/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class StripeSubscriptionsService {
    /**
     * An API endpoint for viewing Stripe Subscriptions.
     * @param data The data for the request.
     * @param data.customerUuid Filter subscriptions by Stripe customer UUID
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @returns PaginatedTStripeSubscriptionList
     * @throws ApiError
     */
    public static stripeSubscriptionsList(data: StripeSubscriptionsListData = {}): CancelablePromise<StripeSubscriptionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_subscriptions/',
            query: {
                customer_uuid: data.customerUuid,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * An API endpoint for viewing Stripe Subscriptions.
     * @returns TStripeSubscription
     * @throws ApiError
     */
    public static stripeSubscriptionsCreate(): CancelablePromise<StripeSubscriptionsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/stripe_subscriptions/'
        });
    }
    
    /**
     * An API endpoint for viewing Stripe Subscriptions.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TStripeSubscription
     * @throws ApiError
     */
    public static stripeSubscriptionsRetrieve(data: StripeSubscriptionsRetrieveData): CancelablePromise<StripeSubscriptionsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/stripe_subscriptions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing Stripe Subscriptions.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TStripeSubscription
     * @throws ApiError
     */
    public static stripeSubscriptionsUpdate(data: StripeSubscriptionsUpdateData): CancelablePromise<StripeSubscriptionsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/stripe_subscriptions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing Stripe Subscriptions.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TStripeSubscription
     * @throws ApiError
     */
    public static stripeSubscriptionsPartialUpdate(data: StripeSubscriptionsPartialUpdateData): CancelablePromise<StripeSubscriptionsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/stripe_subscriptions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing Stripe Subscriptions.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TStripeSubscription
     * @throws ApiError
     */
    public static stripeSubscriptionsDestroy(data: StripeSubscriptionsDestroyData): CancelablePromise<StripeSubscriptionsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/stripe_subscriptions/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
}

export class UnifiedDocumentTemplatesService {
    /**
     * List all document templates (both Form and PDFFormTemplate) with pagination.
     *
     * Query parameters:
     * - search: Search in title/name and description
     * - ordering: Order by field (prefix with - for descending)
     * - limit: Number of results per page
     * - offset: Starting position
     * @param data The data for the request.
     * @param data.limit Number of results per page
     * @param data.offset Starting position
     * @param data.ordering Order by field (prefix with - for descending). Options: created_at, modified_at, title
     * @param data.search Search in title/name and description
     * @returns PaginatedUnifiedDocumentTemplateList
     * @throws ApiError
     */
    public static unifiedDocumentTemplatesList(data: UnifiedDocumentTemplatesListData = {}): CancelablePromise<UnifiedDocumentTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/unified_document_templates/',
            query: {
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search
            }
        });
    }
    
    /**
     * Update a document template (title only).
     *
     * Requires template_type to be specified in the request body.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns UnifiedDocumentTemplate
     * @throws ApiError
     */
    public static unifiedDocumentTemplatesPartialUpdate(data: UnifiedDocumentTemplatesPartialUpdateData): CancelablePromise<UnifiedDocumentTemplatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/unified_document_templates/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Delete a document template.
     *
     * Determines the template type and deletes the appropriate model instance.
     * @param data The data for the request.
     * @param data.id
     * @returns void No response body
     * @throws ApiError
     */
    public static unifiedDocumentTemplatesDestroy(data: UnifiedDocumentTemplatesDestroyData): CancelablePromise<UnifiedDocumentTemplatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/unified_document_templates/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Get the third-party creation token for a template.
     *
     * Returns the token that can be used to create standalone form submissions.
     * @param data The data for the request.
     * @param data.id
     * @returns ThirdPartyDocumentCreationTokenResponse
     * @throws ApiError
     */
    public static unifiedDocumentTemplatesThirdPartyTokenRetrieve(data: UnifiedDocumentTemplatesThirdPartyTokenRetrieveData): CancelablePromise<UnifiedDocumentTemplatesThirdPartyTokenRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/unified_document_templates/{id}/third-party-token/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class UsersService {
    /**
     * An API endpoint for viewing and editing users.
     * @param data The data for the request.
     * @param data.isActive Filter by user active status. Defaults to true. Only SUPERUSERs may set false; other roles are restricted to active users only.
     * @param data.isSuperuser Filter by superuser status
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.search Search by email, first name, last name, or UUID
     * @returns PaginatedTUserList
     * @throws ApiError
     */
    public static usersList(data: UsersListData = {}): CancelablePromise<UsersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/users/',
            query: {
                is_active: data.isActive,
                is_superuser: data.isSuperuser,
                limit: data.limit,
                offset: data.offset,
                search: data.search
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing users.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TUser
     * @throws ApiError
     */
    public static usersCreate(data: UsersCreateData = {}): CancelablePromise<UsersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/users/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing users.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TUser
     * @throws ApiError
     */
    public static usersRetrieve(data: UsersRetrieveData): CancelablePromise<UsersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/users/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing users.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TUser
     * @throws ApiError
     */
    public static usersUpdate(data: UsersUpdateData): CancelablePromise<UsersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/users/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing users.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns TUser
     * @throws ApiError
     */
    public static usersPartialUpdate(data: UsersPartialUpdateData): CancelablePromise<UsersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/users/{uuid}/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * An API endpoint for viewing and editing users.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TUser
     * @throws ApiError
     */
    public static usersDestroy(data: UsersDestroyData): CancelablePromise<UsersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/users/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Admin update user password
     * Allows admins to update another user's password. No current password required.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns void No response body
     * @throws ApiError
     */
    public static usersAdminPasswordUpdatePartialUpdate(data: UsersAdminPasswordUpdatePartialUpdateData): CancelablePromise<UsersAdminPasswordUpdatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/users/{uuid}/admin_password_update/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
    /**
     * Update user avatar
     * Upload a new avatar image for the user.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TUser
     * @throws ApiError
     */
    public static usersUpdateAvatarCreate(data: UsersUpdateAvatarCreateData): CancelablePromise<UsersUpdateAvatarCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/users/{uuid}/update-avatar/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: '',
                403: ''
            }
        });
    }
    
    /**
     * Change password for the current user.
     *
     * Request body:
     * {
     * "new_password1": "new_password",
     * "new_password2": "new_password_confirmation"
     * }
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ChangePasswordResponse
     * @throws ApiError
     */
    public static usersChangePasswordCreate(data: UsersChangePasswordCreateData): CancelablePromise<UsersChangePasswordCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/users/change-password/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class WordDocumentTemplatesService {
    /**
     * An API endpoint for viewing and editing WordDocumentTemplates.
     * @param data The data for the request.
     * @param data.lawField * `Allgemein` - Allgemein
     * * `Arbeitsrecht` - Arbeitsrecht
     * * `Asylrecht` - Asylrecht
     * * `Ausländerrecht` - Ausländerrecht
     * * `Bankrecht` - Bankrecht
     * * `Baurecht` - Baurecht
     * * `Beamtenrecht` - Beamtenrecht
     * * `Bewertungen löschen` - Bewertungen löschen
     * * `Casino` - Casino
     * * `Coaching` - Coaching
     * * `Compliance` - Compliance
     * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
     * * `Datenleck` - Datenleck
     * * `Erbrecht` - Erbrecht
     * * `Familienrecht` - Familienrecht
     * * `Gesellschaftsrecht` - Gesellschaftsrecht
     * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
     * * `Hochschulrecht` - Hochschulrecht
     * * `Immobilienrecht` - Immobilienrecht
     * * `Inkasso` - Inkasso
     * * `IT Recht` - IT Recht
     * * `Insolvenzberatung` - Insolvenzberatung
     * * `Markenrecht` - Markenrecht
     * * `Medien-und Presserecht` - Medien-und Presserecht
     * * `Medizinrecht` - Medizinrecht
     * * `Mietrecht` - Mietrecht
     * * `Migrationsrecht` - Migrationsrecht
     * * `Musikrecht` - Musikrecht
     * * `Notariat` - Notariat
     * * `Personenschäden` - Personenschäden
     * * `Schufa` - Schufa
     * * `Schulrecht` - Schulrecht
     * * `Social Media Recht` - Social Media Recht
     * * `Sozialrecht` - Sozialrecht
     * * `Steuerberatung` - Steuerberatung
     * * `Steuerrecht` - Steuerrecht
     * * `Strafrecht` - Strafrecht
     * * `Tesla_Widerruf` - Tesla_Widerruf
     * * `Tierrecht` - Tierrecht
     * * `Verbraucherrecht` - Verbraucherrecht
     * * `Verkehrsrecht` - Verkehrsrecht
     * * `Versicherungsrecht` - Versicherungsrecht
     * * `Verwaltungsrecht` - Verwaltungsrecht
     * * `Wegrecht` - Wegrecht
     * * `Zivilrecht` - Zivilrecht
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @param data.status Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     * @returns PaginatedTWordDocumentTemplateList
     * @throws ApiError
     */
    public static wordDocumentTemplatesList(data: WordDocumentTemplatesListData = {}): CancelablePromise<WordDocumentTemplatesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/word_document_templates/',
            query: {
                law_field: data.lawField,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                status: data.status
            }
        });
    }
    
    /**
     * An API endpoint for viewing and editing WordDocumentTemplates.
     * @param data The data for the request.
     * @param data.formData
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesCreate(data: WordDocumentTemplatesCreateData = {}): CancelablePromise<WordDocumentTemplatesCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * An API endpoint for viewing and editing WordDocumentTemplates.
     * @param data The data for the request.
     * @param data.uuid Record UUID
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesRetrieve(data: WordDocumentTemplatesRetrieveData): CancelablePromise<WordDocumentTemplatesRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/word_document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Update a word document template.
     * Only superusers can update templates under review.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesUpdate(data: WordDocumentTemplatesUpdateData): CancelablePromise<WordDocumentTemplatesUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v3/word_document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Partially update a word document template.
     * Only superusers can update templates under review.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesPartialUpdate(data: WordDocumentTemplatesPartialUpdateData): CancelablePromise<WordDocumentTemplatesPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/word_document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * An API endpoint for viewing and editing WordDocumentTemplates.
     * @param data The data for the request.
     * @param data.uuid
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesDestroy(data: WordDocumentTemplatesDestroyData): CancelablePromise<WordDocumentTemplatesDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/word_document_templates/{uuid}/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Copy a specific instance of a document template.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesCopyCreate(data: WordDocumentTemplatesCopyCreateData): CancelablePromise<WordDocumentTemplatesCopyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/copy/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Copy AI generated template to current template. Only superusers can copy templates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns unknown
     * @throws ApiError
     */
    public static wordDocumentTemplatesCopyAiToCurrentCreate(data: WordDocumentTemplatesCopyAiToCurrentCreateData): CancelablePromise<WordDocumentTemplatesCopyAiToCurrentCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/copy-ai-to-current/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Create an edit token for editing this template in ONLYOFFICE. Only superusers can edit templates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns unknown
     * @throws ApiError
     */
    public static wordDocumentTemplatesCreateEditTokenCreate(data: WordDocumentTemplatesCreateEditTokenCreateData): CancelablePromise<WordDocumentTemplatesCreateEditTokenCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/create-edit-token/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Generate a PDF preview blob from a Word document template.
     *
     * Can use either the original template or the AI-generated template with placeholders
     * based on the use_ai_template parameter.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns binary
     * @throws ApiError
     */
    public static wordDocumentTemplatesCreateWordDocumentPreviewBlobCreate(data: WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateData): CancelablePromise<WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/create_word_document_preview_blob/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * Generate a Word document template with placeholders from a Word document template.
     * This now runs asynchronously and returns a task ID for progress tracking.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns binary
     * @throws ApiError
     */
    public static wordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreate(data: WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateData): CancelablePromise<WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/create_word_document_template_docx_with_placeholders/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Delete the document template file without deleting the template itself.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns TWordDocumentTemplate
     * @throws ApiError
     */
    public static wordDocumentTemplatesDeleteDocumentCreate(data: WordDocumentTemplatesDeleteDocumentCreateData): CancelablePromise<WordDocumentTemplatesDeleteDocumentCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/delete_document/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Extract AI metadata for a single template.
     * Returns extracted metadata without updating the template.
     * @param data The data for the request.
     * @param data.uuid
     * @returns ExtractedMetadata
     * @throws ApiError
     */
    public static wordDocumentTemplatesExtractMetadataCreate(data: WordDocumentTemplatesExtractMetadataCreateData): CancelablePromise<WordDocumentTemplatesExtractMetadataCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/extract_metadata/',
            path: {
                uuid: data.uuid
            }
        });
    }
    
    /**
     * Reset template to its original version. Only superusers can reset templates.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.formData
     * @returns unknown
     * @throws ApiError
     */
    public static wordDocumentTemplatesResetToOriginalCreate(data: WordDocumentTemplatesResetToOriginalCreateData): CancelablePromise<WordDocumentTemplatesResetToOriginalCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/reset-to-original/',
            path: {
                uuid: data.uuid
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * GET validation data for a word template including placeholders and preview.
     * PATCH to update validation data and regenerate preview.
     * POST to generate Word document with current validation data.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.forceRefresh Force refresh validation data from the template, ignoring cache
     * @param data.useAiTemplate Whether to use the AI-generated template for validation
     * @returns ValidationDataResponse
     * @throws ApiError
     */
    public static wordDocumentTemplatesValidateRetrieve(data: WordDocumentTemplatesValidateRetrieveData): CancelablePromise<WordDocumentTemplatesValidateRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/word_document_templates/{uuid}/validate/',
            path: {
                uuid: data.uuid
            },
            query: {
                force_refresh: data.forceRefresh,
                use_ai_template: data.useAiTemplate
            }
        });
    }
    
    /**
     * GET validation data for a word template including placeholders and preview.
     * PATCH to update validation data and regenerate preview.
     * POST to generate Word document with current validation data.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns GenerateDocumentResponse
     * @throws ApiError
     */
    public static wordDocumentTemplatesValidateCreate(data: WordDocumentTemplatesValidateCreateData): CancelablePromise<WordDocumentTemplatesValidateCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/{uuid}/validate/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * GET validation data for a word template including placeholders and preview.
     * PATCH to update validation data and regenerate preview.
     * POST to generate Word document with current validation data.
     * @param data The data for the request.
     * @param data.uuid
     * @param data.requestBody
     * @returns UpdateValidationDataResponse
     * @throws ApiError
     */
    public static wordDocumentTemplatesValidatePartialUpdate(data: WordDocumentTemplatesValidatePartialUpdateData): CancelablePromise<WordDocumentTemplatesValidatePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/word_document_templates/{uuid}/validate/',
            path: {
                uuid: data.uuid
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Bulk upload multiple Word document templates.
     * Creates draft templates immediately with temporary names.
     * @param data The data for the request.
     * @param data.formData
     * @param data.lawField * `Allgemein` - Allgemein
     * * `Arbeitsrecht` - Arbeitsrecht
     * * `Asylrecht` - Asylrecht
     * * `Ausländerrecht` - Ausländerrecht
     * * `Bankrecht` - Bankrecht
     * * `Baurecht` - Baurecht
     * * `Beamtenrecht` - Beamtenrecht
     * * `Bewertungen löschen` - Bewertungen löschen
     * * `Casino` - Casino
     * * `Coaching` - Coaching
     * * `Compliance` - Compliance
     * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
     * * `Datenleck` - Datenleck
     * * `Erbrecht` - Erbrecht
     * * `Familienrecht` - Familienrecht
     * * `Gesellschaftsrecht` - Gesellschaftsrecht
     * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
     * * `Hochschulrecht` - Hochschulrecht
     * * `Immobilienrecht` - Immobilienrecht
     * * `Inkasso` - Inkasso
     * * `IT Recht` - IT Recht
     * * `Insolvenzberatung` - Insolvenzberatung
     * * `Markenrecht` - Markenrecht
     * * `Medien-und Presserecht` - Medien-und Presserecht
     * * `Medizinrecht` - Medizinrecht
     * * `Mietrecht` - Mietrecht
     * * `Migrationsrecht` - Migrationsrecht
     * * `Musikrecht` - Musikrecht
     * * `Notariat` - Notariat
     * * `Personenschäden` - Personenschäden
     * * `Schufa` - Schufa
     * * `Schulrecht` - Schulrecht
     * * `Social Media Recht` - Social Media Recht
     * * `Sozialrecht` - Sozialrecht
     * * `Steuerberatung` - Steuerberatung
     * * `Steuerrecht` - Steuerrecht
     * * `Strafrecht` - Strafrecht
     * * `Tesla_Widerruf` - Tesla_Widerruf
     * * `Tierrecht` - Tierrecht
     * * `Verbraucherrecht` - Verbraucherrecht
     * * `Verkehrsrecht` - Verkehrsrecht
     * * `Versicherungsrecht` - Versicherungsrecht
     * * `Verwaltungsrecht` - Verwaltungsrecht
     * * `Wegrecht` - Wegrecht
     * * `Zivilrecht` - Zivilrecht
     * @param data.limit Number of results to return per page.
     * @param data.offset The initial index from which to return the results.
     * @param data.ordering Which field to use when ordering the results.
     * @param data.search A search term.
     * @param data.status Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     * @returns PaginatedWordDocumentTemplateList
     * @throws ApiError
     */
    public static wordDocumentTemplatesBulkUploadCreate(data: WordDocumentTemplatesBulkUploadCreateData): CancelablePromise<WordDocumentTemplatesBulkUploadCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/word_document_templates/bulk_upload/',
            query: {
                law_field: data.lawField,
                limit: data.limit,
                offset: data.offset,
                ordering: data.ordering,
                search: data.search,
                status: data.status
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Get the status of a placeholder generation task.
     * @param data The data for the request.
     * @param data.taskId
     * @returns unknown
     * @throws ApiError
     */
    public static wordDocumentTemplatesTaskStatusRetrieve(data: WordDocumentTemplatesTaskStatusRetrieveData): CancelablePromise<WordDocumentTemplatesTaskStatusRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/word_document_templates/task_status/{task_id}/',
            path: {
                task_id: data.taskId
            }
        });
    }
    
}